  <HomeNavBar/>


<section class="scrollable-container container-fluid px-2">
  <div class="row d-flex justify-content-center align-items-center">

    <div class="col-lg-12 col-12 p-0">

      <div class="card border-0 shadow-sm rounded overflow-hidden mb-2 bg-white">

        <!-- COVER -->
        <div class="position-relative">
          <div class="banner-box position-relative overflow-hidden" @click="open_image_viewer(currentBanner)">
            <img v-if="currentBanner" :src="currentBanner" alt="Company Banner" class="banner-image" />
            <div v-else class="banner-placeholder d-flex align-items-center justify-content-center text-muted"></div>
          </div>

          <div v-if="isOwner" class="position-absolute bottom-0 end-0 m-3">
            <button type="button"
              class="btn btn-sm bg-white rounded shadow-sm px-3 border-0 d-flex align-items-center gap-2 pointer"
              @click.stop="triggerFileUploadCover">
              <i class="bi bi-camera-fill text-primary"></i>
              <span class="fw-bold small text-dark d-none d-xl-inline">Change Banner</span>
            </button>
            <input ref="fileInputCover" type="file" accept="image/*" class="d-none" @change="onCoverPictureChange" />
          </div>
        </div>

        <!-- PROFILE BODY -->
        <div class="card-body pt-0 px-0 px-xl-4 pb-4">
          <div
            class="d-flex flex-column flex-xl-row align-items-stretch align-items-xl-end position-relative text-center text-xl-start">

            <!-- AVATAR -->
            <div class="position-relative me-xl-4 mb-3 mb-xl-0 flex-shrink-0 avatar-overlap align-self-center align-self-xl-auto">
              <div
                class="profile-avatar bg-white rounded-circle shadow-lg p-1 border border-2 border-white position-relative">

                <!-- Mobile completion ring -->
                <svg v-if="isOwner" class="position-absolute top-0 start-0 w-100 h-100 d-xl-none text-primary"
                  viewBox="0 0 120 120">
                  <circle cx="60" cy="60" r="56" fill="none" stroke="#e9ecef" stroke-width="5" />
                  <circle cx="60" cy="60" r="56" fill="none" stroke="var(--secondary-color)" stroke-width="5"
                    stroke-linecap="round" :stroke-dasharray="2 * Math.PI * 56"
                    :stroke-dashoffset="(2 * Math.PI * 56) * (1 - (companyData.completion_percentage || 0) / 100)"
                    transform="rotate(90 60 60) scale(-1 1) translate(-120 0)" />
                </svg>

                <!-- % badge -->
                <div v-if="isOwner"
                  class="d-xl-none position-absolute top-0 start-50 translate-middle-x bg-primary text-white rounded-pill px-2 fw-bold shadow-sm border border-2 border-white completion-badge">
                  {{ companyData.completion_percentage || 0 }}%
                </div>

                <!-- inner wrapper -->
                <div class="rounded-circle overflow-hidden w-100 h-100 position-relative">
                  <img v-if="companyData?.company_profile?.length"
                    :src="companyData.company_profile[0].file.file_url || require('@/assets/images/user.svg')"
                    class="w-100 h-100 object-fit-cover"
                    @click="open_profile_image_viewer(companyData.company_profile[0].file.file_url)" />
                  <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center bg-light">
                    <img :src="require('@/assets/images/user.svg')" class="w-50" />
                  </div>
                </div>
              </div>

              <button v-if="isOwner"
                class="btn btn-primary btn-sm rounded-circle position-absolute bottom-0 end-0 d-flex align-items-center justify-content-center border border-3 border-white shadow"
                @click.stop="triggerProfileFileUpload">
                <i class="bi bi-camera-fill"></i>
              </button>
              <input ref="profileFileInput" type="file" accept="image/*" class="d-none"
                @change="onProfilePictureChange" />
            </div>

            <!-- MOBILE STATS ROW — visible on mobile only, sits below avatar -->

            <!-- NAME + STATS -->
            <div class="flex-grow-1 mb-xl-2 mt-2 mt-xl-5">

              <div
                class="d-flex align-items-center gap-2 flex-wrap justify-content-center justify-content-xl-start mb-1">
                <h2 class="fw-bold text-dark mb-0 h3">{{ companyData?.company_name }}</h2>
                <span v-if="membership_name" class="badge bg-soft-primary text-primary rounded px-3 py-1 fw-bold small d-none">
                  {{ membership_name }}
                </span>
              </div>
              <div class="d-flex d-xl-none justify-content-center gap-3 w-100 mt-2 mb-1">
              <div class="text-center">
                <div class="fw-bold text-dark small">{{ companyData?.reports_count || 0 }}</div>
                <div class="text-muted text-xxs">Posts</div>
              </div>
              <div class="vr"></div>
              <div class="text-center " @click="get_followers('following')">
                <div class="fw-bold text-dark small">{{ companyData?.following_count || 0 }}</div>
                <div class="text-muted text-xxs">Following</div>
              </div>
              <div class="vr"></div>
              <div class="text-center" @click="get_followers('followers')">
                <div class="fw-bold text-dark small">{{ companyData?.followers_count || 0 }}</div>
                <div class="text-muted text-xxs">Followers</div>
              </div>
            </div>
              <div class="mobile-profile-actions d-grid margin-inline-auto gap-1 d-xl-none mt-3">
                <button
                  type="button"
                  class="mobile-profile-action text-xxs d-flex flex-column align-items-center justify-content-center gap-1"
                  :class="{ active: show_mobile_owner }"
                  @click="show_mobile_owner = !show_mobile_owner; show_mobile_socials = false"
                >
                  <i class="bi bi-person-circle text-primary"></i>
                  <span>Owner</span>
                </button>

                <button
                  type="button"
                  class="mobile-profile-action text-xxs d-flex flex-column align-items-center justify-content-center gap-1"
                  data-bs-toggle="modal"
                  data-bs-target="#ratings_modal"
                >
                  <i class="bi bi-star-fill text-warning"></i>
                  <span>{{ rating || '0.0' }}</span>
                </button>

                <button
                  type="button"
                  class="mobile-profile-action text-xxs d-flex flex-column align-items-center justify-content-center gap-1"
                  :class="{ active: show_mobile_socials }"
                  @click="show_mobile_socials = !show_mobile_socials; show_mobile_owner = false"
                >
                  <i class="bi bi-share-fill text-primary"></i>
                  <span>Socials</span>
                </button>
              </div>

         <div
          v-if="show_mobile_owner"
          @click="view_profile(companyData)"
          class="mobile-owner-drawer pointer p-2 rounded d-flex d-xl-none align-items-center justify-content-between">
          <span class="d-flex align-items-center">
            <i class="bi bi-person-fill"></i>
          </span>

          <span class="overflow-hidden fw-bold text-dark text-overflow-ellipsis whitespace-nowrap small">
            {{ companyData?.base_profile?.creater?.first_name }}
            {{ companyData?.base_profile?.creater?.last_name }}
          </span>
        </div>

              <div v-if="show_mobile_socials" class="mobile-social-drawer d-xl-none">
                <a
                  v-for="(link, index) in companyData?.social_profiles"
                  :key="index"
                  :href="link.social_link"
                  target="_blank"
                  class="mobile-social-link"
                  :title="link.social_type?.name">
                  <i :class="[
                    'bi',
                    {
                      'instagram': 'bi-instagram text-danger',
                      'facebook': 'bi-facebook text-primary',
                      'linkedin': 'bi-linkedin text-info',
                      'x_twitter': 'bi-twitter-x text-dark',
                      'youtube': 'bi-youtube text-danger',
                      'tiktok': 'bi-tiktok text-dark',
                      'website': 'bi-globe text-secondary'
                    }[link.social_type?.name?.toLowerCase()] || 'bi-link text-muted'
                  ]"></i>
                </a>
                <button
                  v-if="isOwner"
                  type="button"
                  class="mobile-social-link"
                  data-bs-toggle="modal"
                  data-bs-target="#social_modal">
                  <i class="bi bi-plus-lg text-primary"></i>
                </button>
              </div>

              <div
                class="d-none d-xl-flex flex-wrap align-items-center justify-content-center justify-content-xl-start gap-2 mb-2">
                <span class="text-muted small fw-medium">
                  <i class="bi bi-person-circle text-primary me-1"></i>
                  <span class="text-primary pointer text-decoration-underline fw-bold"
                    @click="view_profile(companyData)">
                    {{ companyData?.base_profile?.creater?.first_name }} {{
                    companyData?.base_profile?.creater?.last_name }}
                  </span>
                </span>

                <span class="d-inline-flex align-items-center gap-2 bg-soft-warning p-1 px-3 rounded border border-warning border-opacity-10">
                  <span class="text-warning fw-bold small"><i class="bi bi-star-fill me-1"></i>{{ rating || '0.0' }}</span>
                  <span class="vr bg-warning opacity-50"></span>

                  <button
                    class="btn btn-link p-0 text-dark fw-bold text-xxs text-decoration-underline shadow-none d-xl-none"
                    data-bs-toggle="modal"
                    data-bs-target="#ratings_modal"
                  >
                    {{ total_ratings }} Reviews
                  </button>

                  <span class="text-dark fw-bold text-xxs d-none d-xl-inline-block">
                    {{ total_ratings }} Reviews
                  </span>
                </span>
              </div>
              <div class="d-none d-xl-block mt-1">
                <a v-for="(link, index) in companyData?.social_profiles" :key="index" :href="link.social_link"
                  target="_blank" class="text-decoration-none direct-social-icon me-3  border-white rounded-5"
                  :title="link.social_type?.name">
                  <i :class="[
                    'bi fs-5',
                    {
                      'instagram': 'bi-instagram text-danger',
                      'facebook': 'bi-facebook text-primary',
                      'linkedin': 'bi-linkedin text-info',
                      'x_twitter': 'bi-twitter-x text-dark',
                      'youtube': 'bi-youtube text-danger',
                      'tiktok': 'bi-tiktok text-dark',
                      'website': 'bi-globe text-secondary'
                    }[link.social_type?.name?.toLowerCase()] || 'bi-link text-muted'
                  ]"></i>
                </a>
                <button v-if="isOwner" type="button"
                  class="btn btn-link p-0 text-dark fw-bold text-xxs text-decoration-underline shadow-none"
                  data-bs-toggle="modal" data-bs-target="#social_modal">
                  + add Socials
                </button>
              </div>
            </div>

            <!-- ACTIONS -->
            <div class="d-flex flex-column align-items-center align-items-xl-end gap-2 mt-3 mt-xl-0 ms-xl-3">

              <div v-if="isOwner"
                class="d-none d-xl-flex align-items-center gap-3 p-2 px-3 bg-light rounded border shadow-sm mb-2">
                <div class="circular-progress-container position-relative">
                  <svg class="position-absolute top-0 start-0 w-100 h-100" viewBox="0 0 120 120">
                    <circle cx="60" cy="60" r="54" fill="none" stroke="#e9ecef" stroke-width="8" />
                    <circle cx="60" cy="60" r="54" fill="none" stroke="currentColor" stroke-width="8"
                      stroke-linecap="round" :stroke-dasharray="2 * Math.PI * 54" :stroke-dashoffset="circleOffset"
                      transform="rotate(90 60 60) scale(-1 1) translate(-120 0)" />
                  </svg>
                  <div class="position-absolute top-50 start-50 translate-middle text-center">
                    <span class="fw-bold text-primary text-xxs">{{ companyData?.completion_percentage || 0 }}%</span>
                  </div>
                </div>
                <div class="text-start">
                  <p class="text-xxs fw-bold text-muted text-uppercase mb-0">Profile</p>
                  <p class="text-xxs fw-black text-primary mb-0">Completed</p>
                </div>
              </div>

              <div class="profile-action-buttons d-flex flex-row flex-xl-column gap-2 justify-content-center w-100">

                <button v-if="String(companyData?.base_profile?.creater?.id) !== String(user_details.user_id)"
                  class="btn btn-primary btn-sm rounded text-xs px-3 py-1 border-0 shadow-sm"
                  @click="follow_profile(companyData?.base_profile?.id)">
                  <i class="bi me-1" :class="companyData?.is_following ? 'bi-check-lg' : 'bi-plus'"></i>
                  {{ companyData?.is_following ? 'Following' : 'Follow' }}
                </button>

                <button v-if="String(companyData?.base_profile?.creater?.id) === String(user_details.user_id)"
                  class="btn btn-primary btn-sm rounded text-xxs px-xl-2 border-0 shadow-sm d-none"
                  @click="is_owner_view = !is_owner_view">
                  <i class="bi me-1" :class="is_owner_view ? 'bi-person-badge' : 'bi-eye'"></i>
                  {{ is_owner_view ? 'Manage' : 'Preview' }}
                </button>

              </div>
            </div>


          </div>
          <div v-if="client_features.show_marketplace && !show_catalogue" class="d-flex justify-content-start justify-content-xl-end mt-2">
            <h6 class="btn-link text-decoration-underline text-primary fw-bold mb-0 pointer" @click="go_to_catalogue">
              Catalogue
            </h6>
          </div>
        </div>
      </div>

      <div class="tab-scroller-container mb-1">
        <div class="d-flex align-items-center bg-white rounded shadow-sm border px-1 py-1">

          <!-- Left Arrow -->
          <button class="btn btn-sm me-2 tab-arrow" @click="scroll_tabs('left')" aria-label="Scroll left">
            <i class="bi bi-chevron-left"></i>
          </button>

          <!-- Tabs -->
          <div class="nav nav-pills flex-nowrap flex-grow-1 overflow-hidden" ref="tabsContainer"
            id="businessProfileTabs" role="tablist">

            <button class="nav-link rounded px-2 px-lg-4 me-1 me-lg-2 text-nowrap fs-xsm"
              :class="{ active: !show_catalogue && activeTab === 'about' }" id="about-tab" data-bs-toggle="tab" data-bs-target="#about"
              @click="set_active_profile_tab('about')" type="button" role="tab">
              About
            </button>

            <button class="nav-link rounded px-2 px-lg-4 me-1 me-lg-2 text-nowrap fs-xsm"
              :class="{ active: !show_catalogue && activeTab === 'posts' }" id="posts-tab" data-bs-toggle="tab" data-bs-target="#posts"
              @click="set_active_profile_tab('posts')" type="button" role="tab">
              Feeds
            </button>

            <button class="nav-link rounded px-2 px-lg-4 me-1 me-lg-2 text-nowrap fs-xsm"
              :class="{ active: !show_catalogue && activeTab === 'gallery' }" id="gallery-tab" data-bs-toggle="tab"
              data-bs-target="#gallery" @click="set_active_profile_tab('gallery')" type="button" role="tab">
              Gallery
            </button>

            <button class="nav-link rounded px-2 px-lg-4 me-1 me-lg-2 text-nowrap fs-xsm d-none"
              :class="{ active: activeTab === 'catalogue' }" id="catalogue-tab" data-bs-toggle="tab"
              data-bs-target="#catalogue" @click="go_to_catalogue" type="button" role="tab">
              Catalogue
            </button>



            <button v-for="profile_tab in profile_tabs" :key="profile_tab.id"
              class="nav-link rounded px-2 px-lg-4 me-1 me-lg-2 text-nowrap fs-xsm d-flex align-items-center"
              :class="{ active: !show_catalogue && activeTab === 'tab_' + profile_tab.id }" :id="'tab-btn-' + profile_tab.id"
              data-bs-toggle="tab" :data-bs-target="'#tab-pane-' + profile_tab.id"
              @click="set_active_profile_tab('tab_' + profile_tab.id); on_dynamic_tab_click(profile_tab)" role="tab">
              <i v-if="profile_tab.profile_tab?.is_locked" class="bi bi-lock-fill me-1 small opacity-50"></i>
              {{ profile_tab.profile_tab?.name }}
            </button>

          </div>

          <!-- Right Arrow -->
          <button class="btn btn-sm ms-2 tab-arrow" @click="scroll_tabs('right')" aria-label="Scroll right">
            <i class="bi bi-chevron-right"></i>
          </button>


        </div>
      </div>
      <div class="row">

        <div v-if="!show_catalogue" class="col-lg-3 d-none d-lg-block ">
          <div class="card bg-transparent border rounded shadow-sm d-none d-xl-block p-4 mb-4 ">
            <h6 class="card-header text-muted bg-transparent mb-3">Quick Stats</h6>
            <div class="row g-2">
              <div class="col-6">
                <div class="bg-transparent border shadow-sm p-3 rounded text-center">
                  <h4 class="fw-bold mb-0 text-primary">{{ companyData?.reports_count || 0 }}</h4>
                  <p class="text-muted text-xxs fw-bold text-uppercase mb-0">Posts</p>
                </div>
              </div>
              <div class="col-6">
                <div class="bg-transparent border shadow-sm p-3 rounded text-center">
                  <h4 class="fw-bold mb-0 text-primary">{{ companyData?.report_likes_count || 0 }}</h4>
                  <p class="text-muted text-xxs fw-bold text-uppercase mb-0">Likes</p>
                </div>
              </div>
              <div class="col-6" @click="get_followers('following')">
                <div class="bg-transparent border shadow-sm p-3 rounded text-center">
                  <h4 class="fw-bold mb-0 text-primary">{{ companyData?.following_count || 0 }}</h4>
                  <p class="text-muted text-xxs fw-bold text-uppercase mb-0">following</p>
                </div>
              </div>
              <div class="col-6 cursor-pointer" @click="get_followers('followers')">
                <div class="bg-transparent border shadow-sm p-3 rounded text-center">
                  <h4 class="fw-bold mb-0 text-primary">{{ companyData?.followers_count || 0 }}</h4>
                  <p class="text-muted text-xxs fw-bold text-uppercase mb-0">Followers</p>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div v-if="!show_catalogue" class="tab-content col-lg-6 col-md-12 col-12 " id="businessProfileTabsContent">

          <div class="tab-pane fade" :class="{ 'show active': activeTab === 'about' }" id="about" role="tabpanel">
            <div class="bg-white border rounded shadow-sm p-3 p-xl-4 mb-4 animate-up">
              <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4 pb-3 border-bottom">
                <div class="d-flex align-items-center gap-3">
                  <div class="icon-sq bg-soft-primary d-flex align-items-center justify-content-center">
                    <i class="bi bi-building text-primary"></i>
                  </div>
                  <div>
                    <p class="text-primary text-xs fw-bold mb-1">About</p>
                    <h5 class="fw-bold text-dark mb-0">Business Information</h5>
                  </div>
                </div>
                <button
                  v-if="isOwner"
                  type="button"
                  class="btn btn-primary btn-sm rounded px-3 fw-bold border-0 align-self-start align-self-md-center"
                  @click="$emit('edit_business_profile', companyData)"
                >
                  Edit Profile
                </button>
              </div>

              <div
                v-if="isOwner || companyData?.description"
                class="bg-light rounded border p-3 p-xl-4 mb-4"
              >
                <div class="d-flex justify-content-between align-items-start gap-3 mb-2">
                  <div>
                    <small class="text-primary fw-bold  text-xs">Company Description</small>
                    <div v-html="companyData?.description || 'No description added yet.'" class="text-muted fs-6 lh-lg mt-2"></div>
                  </div>
                  <i
                    v-if="isOwner && companyData?.description"
                    @click="open_company_visibility_modal('show_description')"
                    :class="companyData?.visibility?.show_description ? 'bi bi-globe text-primary' : 'bi bi-lock-fill text-muted'"
                    class="pointer flex-shrink-0"
                  ></i>
                </div>
              </div>

              <div class="row g-3 mb-4">
                <div class="col-12" v-if="isOwner || companyData?.visibility?.show_location">
                  <div class="p-2 rounded border bg-light h-100">
                    <div class="d-flex justify-content-between align-items-center gap-2 mb-2">
                      <div class="d-flex align-items-center gap-2 min-width-0">
                        <div class="icon-sq bg-soft-danger small flex-shrink-0">
                          <i class="bi bi-geo-alt text-danger"></i>
                        </div>
                        <p class="text-xs text-primary fw-bold mb-0">Location</p>
                      </div>
                      <i
                        v-if="isOwner"
                        @click="open_company_visibility_modal('show_location')"
                        :class="companyData?.visibility?.show_location ? 'bi bi-globe text-primary' : 'bi bi-lock-fill text-muted'"
                        class="pointer flex-shrink-0"
                      ></i>
                    </div>
                    <div class="row g-1 mx-0">
                      <div
                        v-for="(line, index) in company_address_lines"
                        :key="`${line}-${index}`"
                        class="col-12 col-md-6 px-1"
                      >
                        <div class="bg-white rounded border px-2 py-2 h-100">
                          <p class="text-dark fw-semibold mb-0 small text-truncate">{{ line }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6" v-if="isOwner || companyData?.visibility?.show_email">
                  <div class="p-2 rounded border bg-light h-100">
                    <div class="d-flex justify-content-between align-items-center gap-2 mb-2">
                      <div class="d-flex align-items-center gap-2 min-width-0">
                        <div class="icon-sq small flex-shrink-0">
                          <i class="bi bi-envelope"></i>
                        </div>
                        <p class="text-xs text-primary fw-bold mb-0">Email</p>
                      </div>
                      <i
                        v-if="isOwner"
                        @click="open_company_visibility_modal('show_email')"
                        :class="companyData?.visibility?.show_email ? 'bi bi-globe text-primary' : 'bi bi-lock-fill text-muted'"
                        class="pointer flex-shrink-0"
                      ></i>
                    </div>
                    <div class="bg-white rounded border px-2 py-2 w-100">
                      <p class="text-dark fw-semibold mb-0 small">{{ companyData?.email || 'N/A' }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6" v-if="isOwner || companyData?.visibility?.show_tell_number">
                  <div class="p-2 rounded border bg-light h-100">
                    <div class="d-flex justify-content-between align-items-center gap-2 mb-2">
                      <div class="d-flex align-items-center gap-2 min-width-0">
                        <div class="icon-sq bg-soft-success small flex-shrink-0">
                          <i class="bi bi-telephone"></i>
                        </div>
                        <p class="text-xs text-primary fw-bold mb-0">Phone</p>
                      </div>
                      <i
                        v-if="isOwner"
                        @click="open_company_visibility_modal('show_tell_number')"
                        :class="companyData?.visibility?.show_tell_number ? 'bi bi-globe text-primary' : 'bi bi-lock-fill text-muted'"
                        class="pointer flex-shrink-0"
                      ></i>
                    </div>
                    <div class="bg-white rounded border px-2 py-2 w-100">
                      <p class="text-dark fw-semibold mb-0 small">{{ companyData?.tell_number || 'N/A' }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-for="section in all_section" :key="section.id" class="mt-1">

                <div class="row g-3">
                  <div v-for="qa in filteredQuestionSections(section)" :key="qa.id" class="col-12 col-md-6">
                    <div class="p-3 bg-light rounded border h-100 position-relative">
                      <div class="d-flex justify-content-between align-items-start gap-2 mb-2">
                        <label class="fw-bold text-primary text-xs mb-0">
                          {{ qa.question?.question }}
                          <span v-if="qa.question?.is_mandatory" class="text-danger">*</span>
                        </label>
                        <i
                          v-if="isOwner && !qa.question?.is_mandatory && getAnswerByQuestionId(qa.question.id)?.answer"
                          :class="(getAnswerByQuestionId(qa.question.id)?.is_visible ?? true) ? 'bi bi-globe text-primary' : 'bi bi-lock-fill text-muted'"
                          class="pointer small flex-shrink-0"
                          @click="open_answer_visibility_modal(getAnswerByQuestionId(qa.question.id))"
                        ></i>
                      </div>

                      <div v-if="isOwner" class="mt-2">
                        <input
                          v-if="qa.question.question_type?.question_type === 'text'"
                          v-model="qa.newAnswer"
                          class="form-control rounded border bg-white px-3 py-2 text-xxs"
                          @input="qa.isChanged = true"
                        />
                        <textarea
                          v-else-if="qa.question.question_type?.question_type === 'textarea'"
                          v-model="qa.newAnswer"
                          class="form-control rounded border bg-white p-3 text-xxs"
                          rows="3"
                          @input="qa.isChanged = true"
                        ></textarea>

                        <select
                          v-else-if="qa.question.question_type?.question_type === 'selection'"
                          v-model="qa.newAnswer"
                          class="form-select rounded border bg-white px-3 py-2 text-xxs"
                          @change="qa.isChanged = true"
                        >
                          <option value="" disabled>Select option</option>
                          <option v-for="opt in qa.question.options" :key="opt.id" :value="opt.option">
                            {{ opt.option }}
                          </option>
                        </select>

                        <div v-else-if="qa.question.question_type?.question_type === 'multiple_choice'" class="ps-1 mt-1">
                          <div v-for="opt in qa.question.options" :key="opt.id" class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              :name="'radio_about_' + qa.id"
                              :value="opt.option"
                              v-model="qa.newAnswer"
                              @change="qa.isChanged = true"
                            />
                            <label class="form-check-label small text-muted">{{ opt.option }}</label>
                          </div>
                        </div>

                        <div v-else-if="qa.question.question_type?.question_type === 'file'" class="mt-2">
                          <div class="d-flex gap-2 align-items-center p-2 bg-white rounded border">
                            <input
                              type="file"
                              class="d-none"
                              :ref="`fileInput_${qa.question.id}`"
                              @change="onFileSelect(qa, $event)"
                            />

                            <div class="flex-grow-1 overflow-hidden pointer" @click="triggerFileInput(qa)">
                              <p class="text-dark small mb-0 text-truncate">
                                {{ qa.newFile ? qa.newFile.name :
                                (getAnswerByQuestionId(qa.question.id)?.files?.[0]?.file?.name || 'No file chosen') }}
                              </p>
                            </div>

                            <div class="d-flex gap-1">
                              <button
                                v-if="qa.newFile || getAnswerByQuestionId(qa.question.id)?.files?.length"
                                type="button"
                                class="btn btn-sm border rounded fw-bold text-primary"
                                @click.stop="open_file_answer_viewer(
                                  qa.newFile ? null : getAnswerByQuestionId(qa.question.id).files[0].file.s3_url,
                                  qa.newFile ? qa.newFile.name : getAnswerByQuestionId(qa.question.id).files[0].file.name
                                )"
                              >
                                View
                              </button>

                              <button
                                type="button"
                                class="btn btn-primary btn-sm rounded d-flex align-items-center justify-content-center"
                                @click.stop="triggerFileInput(qa)"
                              >
                                <i class="bi bi-upload"></i>
                              </button>
                            </div>
                          </div>
                          <div v-if="qa.validation_error" class="text-danger mt-1 fw-bold">
                            <i class="bi bi-exclamation-circle-fill me-1"></i> {{ qa.validation_error }}
                          </div>
                        </div>

                        <input
                          v-else-if="qa.question.question_type?.question_type === 'date'"
                          type="date"
                          v-model="qa.newAnswer"
                          class="form-control rounded border bg-white px-3 py-2 text-xxs"
                          @input="qa.isChanged = true"
                        />
                        <input
                          v-else-if="qa.question.question_type?.question_type === 'number'"
                          type="number"
                          v-model="qa.newAnswer"
                          class="form-control rounded border bg-white px-3 py-2 text-xxs"
                          @input="qa.isChanged = true"
                        />
                        <input
                          v-else-if="qa.question.question_type?.question_type === 'link'"
                          v-model="qa.newAnswer"
                          type="url"
                          class="form-control rounded border bg-white px-3 py-2 text-xxs"
                          placeholder="https://example.com"
                          @input="qa.isChanged = true"
                        />

                        <div v-if="qa.validation_error" class="text-danger text-xxs mt-1 ps-1 animate-up">
                          <i class="bi bi-exclamation-circle-fill me-1"></i> {{ qa.validation_error }}
                        </div>
                      </div>

                      <div v-else class="text-dark fw-bold small py-1">
                        <template v-if="qa.question.question_type?.question_type === 'file'">
                          <div v-if="getAnswerByQuestionId(qa.question.id)?.files?.length" class="d-flex align-items-center">
                            <button
                              class="btn btn-soft-primary btn-sm rounded px-3 fw-bold d-flex align-items-center gap-2"
                              @click="open_file_answer_viewer(getAnswerByQuestionId(qa.question.id).files[0].file.s3_url, getAnswerByQuestionId(qa.question.id).files[0].file.name)"
                            >
                              <i class="bi bi-file-earmark-text"></i>
                              <span>View Document</span>
                            </button>
                          </div>
                          <div v-else class="text-muted fst-italic small">No file provided</div>
                        </template>
                        <template v-else>
                          {{ getAnswerByQuestionId(qa.question.id)?.answer || '---' }}
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="isOwner && all_section.some(s => s.section?.question_sections?.some(q => q.isChanged))"
                class="d-flex justify-content-end mt-4 pt-3 px-3 px-xl-4 pb-3 border-top"
              >
                <button
                  class="btn btn-primary btn-sm rounded px-3 fw-bold border-0"
                  :disabled="isSubmitting"
                  @click="submit_all_answers"
                >
                  <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                  Save All Changes
                </button>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" :class="{ 'show active': activeTab === 'gallery' }" id="gallery" role="tabpanel">
            <div class="card border-0 shadow-sm rounded p-4 mb-4 bg-light animate-up">
              <div class="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                <h5 class="fw-bold text-dark mb-0 d-flex align-items-center">
                  <div class="icon-sq me-2"><i class="bi bi-images text-primary"></i></div>
                  Media Gallery
                </h5>
              </div>

              <div class="row scrollable-container">
                <div v-for="item in galleryMedia" :key="item.id" class="col-6 col-md-3">
                  <div class="gallery-item-wrapper position-relative  rounded shadow-sm mb-1 border cursor-pointer"
                    @click="open_gallery_media(item)">

                    <img v-if="item.type === 'image'" :src="item.url"
                      class="w-100 h-100 object-fit-cover transition-transform duration-300 transform-scale-110-hover" />

                    <video v-else-if="item.type === 'video'" :src="item.url" muted
                      class="w-100 h-100 object-fit-cover transition-transform duration-300 transform-scale-110-hover"></video>


                    <div v-if="item.type === 'video'" class="position-absolute bottom-0 end-0 m-2">
                      <span class="badge bg-dark bg-opacity-75 rounded-pill text-xxs">
                        <i class="bi bi-play-circle-fill me-1"></i> VIDEO
                      </span>
                    </div>
                  </div>
                </div>
                <p v-if="galleryMedia.length === 0" class="text-center text-muted"> No media found</p>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" :class="{ 'show active': activeTab === 'posts' }" id="posts" role="tabpanel" aria-labelledby="posts_tab">
            <div class="row justify-content-center">

              <div>
                <div v-if="String(companyData?.base_profile?.creater?.id) === String(user_details.user_id)">

                  <CreateFeed @new_report="addReportToHome" :companyName="companyData.company_name"
                    :activeProfile="active_profile_data" />
                </div>
                <!-- Posts Section -->
                <div
                  class=" post-section mt-2 p-3 h-150 full-width-mobile overflow-auto scrollable-container padding-x">

                  <div class="d-flex align-items-center temporary-post" v-if="temporaryPost" id="temp-post">
                    <p class="text-xxs fw-bold">{{ temporaryPost.report_name }} - Posting...</p>
                    <div class="spinner-border ms-auto  text-secondary" role="status" aria-hidden="true"></div>
                  </div>
                  <div v-if="reports.length === 0 && is_loading" class="text-center py-5 w-100">
                    <div class="spinner-border text-secondary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2 mb-0 text-muted">Loading feeds...</p>
                  </div>

                  <div v-else>
                    <!-- Scrollable container -->
                    <div v-if="reports.length > 0">

                      <div v-for="report in reports" :key="report.id" :id="'post-' + report.id"
                        class=" card card-hover mb-2 p-3 d-flex flex-column border-bottom rounded border-0 full-width-mobile shadow report-card">
                        <div class="row">
                          <div class="col p-3">
                            <div class="d-flex align-items-start gap-3">
                              <img v-if="!dwypd_domain"
                                :src="report.base_profile?.profile_type === 'personal'
                                      ? (report.base_profile?.user?.profile?.profile_files?.[0]?.file?.url || require('@/assets/images/user.png'))
                                      : (report.base_profile?.company?.base_profile?.profile_files?.[0]?.file?.file_url || require('@/assets/images/user.png'))"
                                loading="lazy"
                                class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0" />

                              <div class="flex-grow-1">
                                <div class="d-flex justify-content-between align-items-start">
                                  <div class="pe-2">
                                    <!-- Name / Company + topic + pin -->
                                    <p v-if="!dwypd_domain" class="fw-500 mb-1 lh-base small">
                                      <span v-if="report?.base_profile?.user?.is_blocked">
                                        Unknown User
                                      </span>
                                      <span
                                        v-else-if="report?.base_profile?.profile_type?.toLowerCase().trim() === 'personal'"
                                        @click="view_profile(report.base_profile?.user?.id)">
                                        {{ report.base_profile?.user?.first_name }} {{
                                        report.base_profile?.user?.last_name }}
                                      </span>
                                      <span v-else @click="view_company(report.base_profile)">
                                        {{ report.base_profile?.company?.company_name || 'Company Name' }}
                                      </span>

                                      <span class="badge bg-warning text-dark ms-2 align-middle">
                                        <i class="bx bxs-bulb me-1"></i>{{ report.topic?.name || '' }}
                                      </span>

                                      <span v-if="report.is_pinned" class="ms-2 text-warning align-middle">
                                        <i class="bx bxs-pin"></i>
                                      </span>
                                    </p>

                                    <!-- Date -->
                                    <p v-if="!dwypd_domain"
                                      class="text-muted small mb-0 d-flex align-items-center gap-1">
                                      <i class="bx bxs-stopwatch"></i>
                                      <span>{{ report.publication_date }}</span>
                                    </p>
                                  </div>

                                  <!-- Three Dots Menu -->
                                  <div class="dropstart ms-2" @click.stop
                                    v-if="(String(report.base_profile?.user?.id) === String(user_details.user_id) && token_exists) || user_details.user_role === 'admin'">
                                    <a href="" class="text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                      aria-expanded="false">
                                      <i class="bi bi-three-dots-vertical"></i>
                                    </a>
                                    <ul class="dropdown-menu dropdown-menu-end lh-sm"
                                      aria-labelledby="dropdownMenuButton">
                                      <a v-if="user_details.user_role === 'admin'"
                                        class="dropdown-item small fw-bold border-bottom d-none" href=""
                                        @click.prevent="togglePinReport(report)">
                                        <i :class="report.is_pinned ? 'bx bx-pin fs-6' : 'bx bxs-pin fs-6'"></i>
                                        {{ report.is_pinned ? 'Unpin' : 'Pin' }}
                                      </a>
                                      <li
                                        v-if="(soulcity_domain && user_details.user_role === 'admin') || String(report.base_profile?.user?.id) === String(user_details.user_id)">
                                        <a class="dropdown-item small fw-bold" href="" data-bs-toggle="modal"
                                          data-bs-target="#edit_report_modal" @click="edit_report(report)"
                                          v-if="report.total_comments === 0 && report.total_likes === 0">
                                          <i class="bx bxs-edit fs-6"></i> Edit
                                        </a>
                                      </li>
                                      <li>
                                        <a class="dropdown-item small fw-bold d-none" href=""
                                          @click.prevent="open_event_modal(report.id)">
                                          <i class="bi bi-calendar-event fs-6"></i> Add Event
                                        </a>
                                      </li>
                                      <li>
                                        <a class="dropdown-item small fw-bold" href=""
                                          @click.prevent="deleteReport(report.id)">
                                          <i class="bx bxs-trash-alt fs-6"></i> Delete
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>


                            <!-- Report Description -->
                            <p class="fw-500 text-xxs mt-2 " v-if="report.name">{{ report.name }}</p>
                            <div class="quill-wrapper">
                              <div v-html="displayedDescription(report)" :class="['ql-editor quill-content','fs-6','lh-lg']">
                              </div>

                              <!-- Read More / Read Less Toggle (keep commented if not needed) -->
                              <!--
                            <span
                              v-if="report.description && report.description.length > 0 && !soulcity_domain"
                              class="text-secondary cursor-pointer text-xxs ms-1"
                              @click="toggleDescription(report.id)"
                            >
                              {{ isExpanded(report.id) ? 'Read Less' : 'Read More' }}
                              <i v-if="!isExpanded(report.id)" class="bx bx-down-arrow-circle"></i>
                              <i v-else class="bx bx-up-arrow-circle"></i>
                            </span>
                            -->
                            </div>

                            <!-- Images -->
                            <!-- ✅ IMAGE FILES -->
                            <div v-if="getCarouselImages(report).length" class="business-carousel">
                              <div :id="'carousel-' + report.id" class="carousel slide">
                                <!-- Indicators -->
                                <div v-if="getCarouselImages(report).length>1" class="carousel-indicators">
                                  <button v-for="(src, i) in getCarouselImages(report)" :key="'indicator-' + i"
                                    type="button" :data-bs-target="'#carousel-' + report.id" :data-bs-slide-to="i"
                                    :class="{ active: i === 0 }" aria-current="i === 0 ? 'true' : undefined"
                                    :aria-label="'Slide ' + (i + 1)"></button>
                                </div>

                                <!-- Carousel Inner -->
                                <div class="carousel-inner">
                                  <div v-for="(src, i) in getCarouselImages(report)" :key="'carousel-img-' + i"
                                    :class="['carousel-item', { active: i === 0 }]">
                                    <img :src="src.file.url" alt="Feed Image" class="carousel-img media-item rounded-5"
                                      @click="display_comment_modal(report)" />
                                  </div>
                                </div>

                                <!-- Controls -->
                                <div v-if="getCarouselImages(report).length>1">
                                  <button class="carousel-control-prev" type="button"
                                    :data-bs-target="'#carousel-' + report.id" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                  </button>
                                  <button class="carousel-control-next" type="button"
                                    :data-bs-target="'#carousel-' + report.id" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex flex-column" v-if="report.report_files && report.report_files.length">
                              <div v-for="(fileObj, index) in report.report_files" :key="index" class="mb-3">

                                <!-- ✅ IMAGE FILES -->
                                <div class="media-container image-only mb-3" v-if="fileObj?.file?.url &&
                                  (fileObj.file.url.includes('.jpg') ||
                                  fileObj.file.url.includes('.JPG') ||
                                  fileObj.file.url.includes('.png') ||
                                  fileObj.file.url.includes('.PNG') ||
                                  fileObj.file.url.includes('.avif') ||
                                  fileObj.file.url.includes('.AVIF') ||
                                  fileObj.file.url.includes('.jpeg') ||
                                  fileObj.file.url.includes('.JPEG') ||
                                  fileObj.file.url.includes('.webp') ||
                                  fileObj.file.url.includes('.WEBP'))">
                                  <!-- <img :src="fileObj.file.url" alt="Feed Image" class="media-item rounded-5"
                                  @click="display_comment_modal(report)" /> -->
                                </div>

                                <!-- ✅ AUDIO FILES -->
                                <div class="media-container video-audio mb-3" v-else-if="fileObj?.file?.url &&
                                      (fileObj.file.url.includes('.mp3') ||
                                        fileObj.file.url.includes('.wav'))">
                                  <audio controls class="rounded-3 p-1">
                                    <source :src="fileObj.file.url"
                                      :type="fileObj.file.url.includes('.mp3') ? 'audio/mpeg' : 'audio/wav'" />
                                    Your browser does not support the audio element.
                                  </audio>
                                </div>

                                <!-- ✅ VIDEO FILES -->
                                <div class="media-container video-audio mb-3"
                                  v-else-if="fileObj?.file?.url && /\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)">
                                  <video controls class="media-item rounded-5" @click="display_comment_modal(report)">
                                    <source :src="fileObj.file.url" />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>

                                <!-- ✅ OTHER FILES (PDF, DOCX, ZIP, ETC.) -->
                                <!-- ✅ OTHER FILES (PDF, DOCX, ZIP, ETC.) -->
                                <div v-else
                                      class="uploaded-file d-flex align-items-center justify-content-between p-3 mb-2 rounded shadow-sm"
                                      @click="open_preview(fileObj)">
                                      <!-- File Info -->
                                      <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                                        <div class="d-flex align-items-center justify-center me-3 flex-shrink-0">
                                          <img
                                            v-if="fileObj?.file?.url"
                                            :src="getFileIcon(fileObj.file.url)"
                                            class="file-icon"/>
                                        </div>
              
                                        <div class="file-details">
                                          <span class="file-name d-block">
                                            {{ getFileName(fileObj?.file?.url) }}
                                          </span>
                                        </div>
                                      </div>
                                      <!-- Actions -->
                                      <div class="d-flex align-items-center gap-3 flex-shrink-0 ms-3">
                                        <a
                                          :href="fileObj?.file?.url"
                                          download
                                          :title="getFileName(fileObj?.file?.url)"
                                          class="file-action-btn"
                                          @click.stop
                                        >
                                          <i class="bi bi-download"></i>
                                        </a>
              
                                        <a
                                          @click.stop="toggle_library_save(fileObj)"
                                          class="file-action-btn"
                                          :title="isInLibrary(fileObj?.file.id) ? 'Remove from Library' : 'Save to Library'"
                                        >
                                          <i
                                            class="bi"
                                            :class="isInLibrary(fileObj?.file.id)
                                              ? 'bi-bookmark-check-fill text-dark'
                                              : 'bi-bookmark text-muted'"
                                          ></i>
                                        </a>
                                      </div>
                                    </div>


                              </div>
                            </div>


                            <div v-if="report.linkPreview"
                              class="link-preview rounded mt-2 p-2 position-relative border">

                              <a :href="report.report_link" target="_blank" class="text-decoration-none">
                                <img v-if="report.linkPreview.image" :src="report.linkPreview.image"
                                  class="img-fluid rounded" />
                                <div class="fw-bold mt-2">{{ report.linkPreview.title }}</div>
                                <div v-if="!report.linkPreview.image" class="text-muted small">{{
                                  report.linkPreview.description
                                  }}</div>
                              </a>
                            </div>
                            <!-- ✅ Event Display -->
                            <div
                              v-if="report.event_report && report.event_report.length && report.event_report[0].event.end_date >= currentDate"
                              class="mt-3">
                              <div v-for="event in [report.event_report[0].event]" :key="event.id || 'event-report-0'"
                                class="card border rounded-5 shadow-sm mb-4 mt-3" @click.stop>
                                <div class="card-body">
                                  <div class="d-flex justify-content-between align-items-start">
                                    <div class="flex-grow-1 pe-3">
                                      <div class="d-flex flex-wrap">
                                        <p class="fw-semibold ms-3">Event : {{ event.event_name }}</p>

                                      </div>
                                    </div>
                                  </div>
                                  <hr class="my-0">
                                  <div class="row g-4 mb-4">
                                    <!-- Event Period -->
                                    <div class="col-12 col-md-4">
                                      <div class="d-flex gap-3">
                                        <div
                                          class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                                          <i class="bi bi-calendar-event fs-5 text-secondary"></i>
                                        </div>
                                        <div class="flex-grow-1">
                                          <div class="text-uppercase text-muted small fw-semibold mb-1">Event Period
                                          </div>
                                          <div class="fw-semibold text-xxs">{{event.start_date }}</div>
                                          <div class="text-muted text-xxs">{{ event.start_time ? event.start_time : ''
                                            }}
                                            <span v-if="event.end_time"> to {{ event.end_time }}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-12 col-md-4">
                                      <div class="d-flex gap-3">
                                        <div
                                          class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                                          <i class="bi bi-geo-alt fs-5 text-secondary"></i>
                                        </div>
                                        <div class="flex-grow-1">
                                          <div class="text-uppercase text-muted text-xxs fw-semibold mb-1">Location
                                          </div>
                                          <div class="fw-semibold text-xxs">{{ event.location || 'Not set' }}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Actions -->
                                  <div class="d-flex justify-content-end align-items-center gap-2 flex-wrap">
                                    <button v-if="event.is_free"
                                      class="btn btn-primary btn-sm rounded px-3 py-1 shadow text-xxs"
                                      @click.stop="openModal(event)">
                                      <i class="bi bi-check-circle me-1"></i> RSVP
                                    </button>

                                    <button v-else class="btn btn-primary btn-sm rounded px-3 py-1 shadow text-xxs"
                                      @click.stop="openModal(event)">
                                      <i class="bi bi-ticket-perforated me-1"></i> Buy Ticket
                                    </button>
                                    <a href="/view_events" class="btn btn-primary btn-sm rounded px-3 py-1 text-xxs">

                                      View Event
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div v-if="dwypd_domain && report && report.authors && report.authors.length"
                              class="me-5 py-1 rounded bg-light d-inline-flex align-items-start flex-wrap gap-2">
                              <span class="fw-bold text-primary me-2">Authors:</span>
                              <span v-for="(author, index) in report.authors" :key="index"
                                class="badge bg-primary text-white d-inline-flex align-items-center gap-1 mt-1">

                                <a v-if="author.author_link" :href="author.author_link" target="_blank"
                                  class="text-white" @click.stop>
                                  {{ author.author_name }}
                                </a>
                                <span v-else>{{ author.author_name }}</span>

                              </span>
                            </div>


                            <!-- Likes and Comments Count -->
                            <div class="text-gray mx-2 mt-1 text-end pointer">
                              <span class="me-2" @click="open_likes_modal(report.likes)" data-bs-toggle="modal"
                                data-bs-target="#likes_modal">
                                {{ report.total_likes }}
                                <img src="@/assets/images/like (1).png" class="mb-2 pointer" width="16" height="16"
                                  alt="">
                              </span>
                              <span>{{ report.total_comments }}
                                <img src="@/assets/images/speech-bubble.png" class="pointer" alt="" width="16"
                                  height="16">
                              </span>
                            </div>

                            <!-- Action Buttons -->
                            <div
                              class="d-flex justify-content-between align-items-center border-top border-bottom px-2 py-1 mb-2">
                              <div class="d-flex align-items-center me-3">
                                <!-- Like button -->
                                <span v-if="!likedReports[report.id]" class="d-flex align-items-center fw-500 pointer"
                                  @click.stop="likeReport(report)">
                                  <img src="@/assets/images/like.png" alt="" width="20" height="20" class="pointer">
                                  <span class="text-purple text-xxs mx-1">Like</span>
                                </span>

                                <!-- Unlike button -->
                                <span v-else class="d-flex align-items-center fw-500 pointer"
                                  @click.stop="unlikeReport(report)">
                                  <img src="@/assets/images/like (1).png" alt="" width="20" height="20" class="pointer">
                                  <span class="text-xxs mx-1">Unlike</span>
                                </span>

                              </div>
                              <div
                                :class="`d-flex align-items-center me-3  ${!report.can_comment ? 'comment-disabled' : 'pointer'}`"
                                @click="active_comment_report_id = report.id">
                                <img src="@/assets/images/speech-bubble.png" alt="" width="20" height="20"
                                  class="pointer">
                                <span class="fw-500 text-xxs mx-1">Comment</span>
                              </div>
                              <!-- Share Menu -->
                              <div class="d-flex align-items-center me-2 menu mt-1 bg-white text-xxs" @click.stop>
                                <input type="checkbox" :id="'menu-open-' + report.id" class="menu-open"
                                  name="menu-open" />
                                <label :for="'menu-open-' + report.id"
                                  class="menu-open-button d-flex align-items-center" @click="boon">
                                  <img src="@/assets/images/share (1).png" width="20" height="20" alt=""
                                    class="pointer">
                                  <span class="mx-1 fw-500 t">Share</span>
                                </label>

                                <!-- Copy Link -->
                                <a @click="copyReportLinkToClipboard(report)" class="menu-item bg-white  shadow-sm">
                                  <span @click="closeMenu(report.id)">
                                    <i class="bi bi-link fs-4 copy text-primary text-xxs"></i>
                                  </span>
                                </a>

                                <!-- Twitter -->
                                <a :href="'https://twitter.com/intent/tweet?url=' + encodeURIComponent(baseUrl(report,'report'))"
                                  target="_blank" class="menu-item bg-white  shadow-sm" @click="closeMenu(report.id)">
                                  <i class="bi bi-twitter-x"></i>
                                </a>

                                <!-- LinkedIn -->
                                <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(baseUrl(report,'report'))"
                                  target="_blank" class="menu-item bg-white  shadow-sm linkedin-share-btn"
                                  @click="closeMenu(report.id)">
                                  <i class="bi bi-linkedin"></i>
                                </a>

                                <!-- Facebook -->
                                <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(baseUrl(report,'report'))"
                                  target="_blank" class="menu-item bg-white  shadow-sm facebook-share-btn"
                                  @click="closeMenu(report.id)">
                                  <i class="bi bi-facebook"></i>
                                </a>

                                <!-- WhatsApp -->
                                <a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(baseUrl(report,'report'))"
                                  target="_blank" class="menu-item bg-white  shadow-sm whatsapp-share-btn"
                                  @click="closeMenu(report.id)">
                                  <i class="bi bi-whatsapp"></i>
                                </a>

                                <!-- Copy Toast -->
                                <!-- <div aria-live="polite" aria-atomic="true"
                                  class="position-fixed top-0 start-50 translate-middle-x p-3"
                                  style="z-index: 1080;">
                              <div id="copyToast" class="toast bg-primary border-0 text-white" role="alert"
                                aria-live="assertive" aria-atomic="true">
                                <div class="d-flex">
                                  <div class="toast-body"></div>
                                  <button type="button" class="btn-close btn-close-white me-2 m-auto"
                                    data-bs-dismiss="toast" aria-label="Close"></button>
                                </div>
                              </div>
                            </div> -->

                              </div>

                            </div>


                            <div class="d-flex align-items-center border rounded-pill mb-3 p-0"
                              v-if="active_comment_report_id === report.id">
                              <img src="@/assets/images/user.png" alt="User" class="rounded-circle mx-2" width="32"
                                height="32">
                              <input type="text" class="form-control border-0 rounded-5" id="comment_text_area"
                                v-model="commentText" placeholder="Write a comment" aria-label="Recipient's username"
                                aria-describedby="button-addon2">
                              <div class="d-flex align-items-center">
                                <button class="btn btn-sm text-xxs" type="button" id="button-addon2"
                                  @click="submit_comment(report.id)"><i class="bi bi-send fs-5"></i></button>
                              </div>
                            </div>
                            <!-- Comments Component -->
                            <Comments :comments="report.comments" :report-id="report.id"
                              @add-comment="handleAddComment" :activeProfile="active_profile_data" />

                          </div>
                        </div>
                      </div>
                      <div v-if="is_loading" class="text-center py-3">
                        <div class="spinner-border text-secondary" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="mt-2 mb-0 text-muted">Loading...</p>
                      </div>


                    </div>

                    <div v-else class="text-center py-3">
                      <p class="mt-2 mb-0 text-muted">No reports found.</p>
                    </div>


                  </div>
                </div>
              </div>
            </div>

          </div>
          <div v-for="profile_tab in profile_tabs" :key="'tp-' + profile_tab.id" class="tab-pane fade"
            :class="{ 'show active': activeTab === 'tab_' + profile_tab.id }"
            :id="'tab-pane-' + profile_tab.id" role="tabpanel">
            <div
              v-if="profile_tab?.profile_tab?.is_locked && String(companyData?.base_profile?.creater.id) !== String(user_details.user_id) && !profile_tab?.access_approved">
              <div class=" rounded p-2 text-center  animate-up">
                <i class="bi bi-lock-fill display-5 text-primary mb-3"></i>
                <h4 class="fw-bold">Tab Locked</h4>
                <p class="text-muted small">
                  <span v-if="!profile_tab?.access_requested">You do not have access to view this tab.</span>
                  <span v-else>You have already requested access. Waiting for approval.</span>
                </p>
                <button v-if="profile_tab?.access_rejected" class="btn btn-primary rounded"
                  @click="request_tab_access(profile_tab)">
                  Appeal Access Request
                </button>
                <!-- Request Access button for requesting-->
                <button v-else-if="!profile_tab?.access_requested" class="btn btn-primary rounded"
                  @click="request_tab_access(profile_tab)">
                  Request Access
                </button>
              </div>
            </div>

            <div v-else class="card border-0 shadow-sm rounded bg-white overflow-hidden animate-up">
              <div v-if="isOwner && profile_tab?.profile_tab?.is_locked"
                class="bg-light border-bottom p-2 d-flex justify-content-center gap-2">
                <button class="btn rounded px-4 btn-sm fw-bold shadow-xs"
                  :class="(!profile_tab.active_sub_tab || profile_tab.active_sub_tab === 'info') ? 'btn-primary text-white shadow' : 'btn-light'"
                  @click="profile_tab.active_sub_tab = 'info'">Details</button>
                <button class="btn rounded px-4 btn-sm fw-bold shadow-xs position-relative"
                  :class="profile_tab.active_sub_tab === 'access' ? 'btn-primary text-white shadow' : 'btn-light'"
                  @click="profile_tab.active_sub_tab = 'access'">
                  Access Management
                  <span
                    v-if="companyData.tab_access_requests.filter(r => (r.status === 'pending' && r.tab_key_id === profile_tab.id)).length"
                    class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger border border-white"
                    style="font-size: 0.6rem;">
                    {{ companyData.tab_access_requests.filter(r => (r.status === 'pending' && r.tab_key_id ===
                    profile_tab.id)).length }}
                  </span>
                </button>
              </div>

              <div class="p-3 rounded">
                <div v-if="!profile_tab.active_sub_tab || profile_tab.active_sub_tab === 'info'">
                  <div class="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom rounded">
                    <h5 class="fw-bold text-dark mb-0 d-flex align-items-center">
                      <div class="icon-sq bg-light me-2"><i class="bi bi-info-circle text-primary"></i></div>
                      {{ profile_tab.profile_tab.name }} Details
                    </h5>
                    <button v-if="isOwner" class="btn btn-primary btn-sm rounded px-3 text-xxs border-0 shadow-sm"
                      @click="profile_tab.show_forms = !profile_tab.show_forms">
                      {{ profile_tab.show_forms ? 'Cancel Entry' : '+ Add New Entry' }}
                    </button>
                  </div>

                  <div v-if="profile_tab.show_forms"
                    class="bg-light p-4 rounded mb-5 border-primary border border-dashed animate-up">
                    <div v-for="form_wrap in profile_tab.forms" :key="'f_'+form_wrap.form.id">
                      <h6 class="fw-bold text-primary mb-4 text-uppercase small ls-1">New Record</h6>

                      <div v-for="section in form_wrap.form.form_sections" :key="'s_'+section.section.id" class="mb-4">
                        <p class="text-xxs fw-bold text-muted text-uppercase mb-3 ls-1 border-bottom pb-1">
                          {{ section.section.name }}
                        </p>

                        <div class="row g-3">
                          <div v-for="qa in section.section.question_sections" :key="'q_'+qa.id"
                            class="col-12 col-md-6">
                            <div
                              class="p-3 bg-light rounded border shadow-xs h-100 d-flex flex-column justify-content-between">
                              <div>
                                <label class="fw-bold text-primary text-xxs text-uppercase mb-2 d-block">
                                  {{ qa.question.question }}
                                  <span v-if="qa.question.is_mandatory" class="text-danger">*</span>
                                </label>

                                <input v-if="qa.question.question_type?.question_type === 'text'" type="text"
                                  v-model="qa.newAnswer"
                                  class="form-control rounded border-light-subtle px-3 py-2 text-xxs"
                                  @input="qa.isChanged = true">

                                <textarea v-else-if="qa.question.question_type?.question_type === 'textarea'"
                                  v-model="qa.newAnswer" class="form-control rounded border-light-subtle p-3 text-xxs"
                                  rows="3" @input="qa.isChanged = true"></textarea>

                                <select v-else-if="qa.question.question_type?.question_type === 'selection'"
                                  v-model="qa.newAnswer"
                                  class="form-select rounded border-light-subtle px-3 py-2 text-xxs"
                                  @change="qa.isChanged = true">
                                  <option value="" disabled>Select option</option>
                                  <option v-for="opt in qa.question.options" :key="opt.id" :value="opt.option">{{
                                    opt.option }}</option>
                                </select>

                                <div v-else-if="qa.question.question_type?.question_type === 'multiple_choice'"
                                  class="ps-1 mt-1">
                                  <div v-for="opt in qa.question.options" :key="opt.id" class="form-check">
                                    <input class="form-check-input" type="radio" :name="'radio_entry_' + qa.id"
                                      :value="opt.option" v-model="qa.newAnswer" @change="qa.isChanged = true">
                                    <label class="form-check-label small text-muted text-xxs">{{ opt.option }}</label>
                                  </div>
                                </div>

                                <div v-else-if="qa.question.question_type?.question_type === 'checkbox'"
                                  class="mt-1 d-flex flex-wrap gap-2">
                                  <div v-for="opt in qa.question.options" :key="opt.id" class="form-check">
                                    <input type="checkbox" class="form-check-input" :id="'cb_entry_' + opt.id"
                                      :checked="qa.newAnswer?.includes(opt.option)"
                                      @change="toggleCheckbox(qa, opt.option, $event.target.checked); qa.isChanged = true" />
                                    <label class="form-check-label small text-muted text-xxs"
                                      :for="'cb_entry_' + opt.id">{{ opt.option }}</label>
                                  </div>
                                </div>

                                <div v-else-if="qa.question.question_type?.question_type === 'file'" class="mt-1">
                                  <div
                                    class="d-flex gap-2 align-items-center p-2 bg-light rounded border border-light-subtle">
                                    <input type="file" class="d-none" :ref="`fileInputEntry_${qa.question.id}`"
                                      @change="onFileSelect(qa, $event)" />
                                    <button type="button"
                                      class="btn btn-white btn-sm rounded-pill border shadow-xs text-xxs px-3"
                                      @click="$refs[`fileInputEntry_${qa.question.id}`][0].click()">Upload</button>
                                    <span class="text-truncate small text-muted text-xxs">{{ qa.newFile ?
                                      qa.newFile.name : 'No file chosen' }}</span>
                                  </div>
                                </div>

                                <input v-else-if="['date', 'number'].includes(qa.question.question_type?.question_type)"
                                  :type="qa.question.question_type.question_type" v-model="qa.newAnswer"
                                  class="form-control rounded border-light-subtle px-3 py-2 text-xxs"
                                  @input="qa.isChanged = true" />

                                <input v-else-if="qa.question.question_type?.question_type === 'link'"
                                  v-model="qa.newAnswer" type="url"
                                  class="form-control rounded-3 border-light-subtle px-3 py-2 text-xxs"
                                  placeholder="https://" @input="qa.isChanged = true" />
                              </div>

                              <div v-if="qa.validation_error"
                                class="text-danger text-xxs mt-2 pt-2 border-top border-danger border-opacity-10 animate-up">
                                <i class="bi bi-exclamation-circle-fill me-1"></i> {{ qa.validation_error }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="text-end  border-top">
                        <button class="btn btn-primary btn-sm rounded shadow text-xxs px-3" :disabled="isSubmitting"
                          @click="submit_tab_form_answers(profile_tab, form_wrap)">
                          <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                          SUBMIT
                        </button>
                      </div>
                    </div>
                  </div>

                  <div v-for="form_wrap in profile_tab.forms" :key="'list_'+form_wrap.form.id">
                    <div v-for="submission in form_wrap.submissions" :key="submission.id"
                      class="card border shadow-xs rounded mb-4 bg-white overflow-hidden animate-up">

                      <div
                        class="card-header bg-light border-bottom px-4 py-3 d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                          <div class="icon-sq bg-light me-2" style="width: 32px; height: 32px;">
                            <i class="bi bi-clipboard-check text-primary small"></i>
                          </div>
                          <h6 class="fw-bold mb-0 text-dark small text-uppercase ls-1">Information Record</h6>
                        </div>
                        <span class="badge bg-soft-secondary text-muted rounded-pill px-3 py-1 text-xxs fw-bold">
                          SUBMITTED ON {{ new Date(submission.created_at).toLocaleDateString() }}
                        </span>
                      </div>

                      <div class="card-body p-4">
                        <div class="row g-3">
                          <div v-for="ans in submission.answers" :key="ans.id" class="col-12 col-md-6">
                            <div class="p-3 bg-light rounded border ">
                              <p class="text-xxs text-primary fw-bold text-uppercase mb-1 ls-1">{{ ans.question_text }}
                              </p>

                              <div class="text-muted fw-bold small py-1">
                                <template v-if="ans.answer_type === 'file' && ans.files?.length">
                                  <button class="btn btn-link p-0 text-decoration-underline text-xxs fw-bold"
                                    @click="open_file_answer_viewer(ans.files[0].file.s3_url, ans.files[0].file.name)">
                                    <i class="bi bi-file-earmark-text me-1"></i> View Attached File
                                  </button>
                                </template>

                                <template v-else-if="ans.answer_type === 'link' && ans.answer">
                                  <a :href="ans.answer" target="_blank" class="text-muted text-decoration-underline">{{
                                    ans.answer }}</a>
                                </template>

                                <template v-else class="text-muted ">
                                  {{ ans.answer || '---' }}
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div v-if="profile_tab.forms?.every(f => !f.submissions?.length) && !profile_tab.show_forms"
                    class="text-center py-5">
                    <div class="icon-sq bg-light mx-auto mb-3"><i class="bi bi-clipboard-data text-muted"></i></div>
                    <p class="text-muted small">No entries found for this tab.</p>
                  </div>
                </div>

                <div v-if="profile_tab.active_sub_tab === 'access'">
                  <div class="row g-4">
                    <div class="col-lg-6">
                      <h6
                        class="fw-bold mb-3 d-flex align-items-center text-primary border-start border-success border-5 ps-2">
                        Authorized Members
                      </h6>
                      <div
                        v-if="companyData.tab_access_requests.filter(r => (r.status === 'approved' && r.tab_key_id === profile_tab.id)).length">
                        <div
                          v-for="mem in companyData.tab_access_requests.filter(r => (r.status === 'approved' && r.tab_key_id === profile_tab.id))"
                          :key="mem.id"
                          class="p-3 bg-light rounded py-4 border shadow-xs mb-2 animate-up mt-2 p-3 h-50 full-width-mobile overflow-auto scrollable-container padding-x">

                          <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center gap-3 overflow-hidden">
                              <div
                                class="avatar-xs rounded bg-primary text-white d-flex align-items-center justify-content-center fw-bold flex-shrink-0 p-2 text-xxs">
                                {{ mem.requester.creater.first_name[0] }}{{ mem.requester.creater.last_name[0] }}
                              </div>
                              <div class="overflow-hidden">
                                <p class="text-dark fw-bold mb-0 small text-truncate">{{
                                  mem.requester.creater.first_name }} {{ mem.requester.creater.last_name }}</p>
                                <p class="text-xxs text-muted mb-0">Access Granted</p>
                              </div>
                            </div>

                            <button @click="reject_tab_access_request(mem)"
                              class="btn btn-secondary rounded text-xxs fw-bold ">Revoke Access</button>
                          </div>
                        </div>
                      </div>

                      <div v-else class="text-center py-5 bg-light rounded border">
                        <p class="text-muted small mb-0">No active members yet.</p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <h6
                        class="fw-bold mb-2 d-flex align-items-center text-primary border-start border-primary border-4 ps-2">
                        Pending Requests
                      </h6>

                      <div
                        v-if="companyData.tab_access_requests.filter(r => (r.status === 'pending' && r.tab_key_id === profile_tab.id)).length"
                        class="overflow-auto pe-2">
                        <div
                          v-for="req in companyData.tab_access_requests.filter(r => (r.status === 'pending' && r.tab_key_id === profile_tab.id))"
                          :key="req.id"
                          class="p-3 bg-light rounded border mt-2 p-3 h-150 full-width-mobile overflow-auto scrollable-container padding-x shadow-xs mb-3 animate-up">

                          <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center gap-3 overflow-hidden">
                              <div
                                class="avatar-xs rounded bg-primary text-white d-flex align-items-center justify-content-center fw-bold flex-shrink-0 p-2 text-xxs">

                                {{ req.requester.creater.first_name[0] }}{{ req.requester.creater.last_name[0] }}
                              </div>
                              <div class="overflow-hidden">
                                <p class="text-xxs text-muted fw-bold text-uppercase mb-0">Requester</p>
                                <p class="text-dark fw-bold mb-0 small text-truncate">{{
                                  req.requester.creater.first_name }} {{ req.requester.creater.last_name }}</p>
                                <p class="text-xxs text-muted text-truncate mb-0">{{ req.requester.creater.email }}</p>
                              </div>
                            </div>

                            <div class="d-flex gap-2 ms-2">
                              <button @click="approve_tab_access_request(req)"
                                class="btn btn-success btn-sm rounded px-3 fw-bold text-xxs shadow-sm">Approve</button>
                              <button @click="reject_tab_access_request(req)"
                                class="btn btn-secondary btn-sm rounded px-3 fw-bold text-xxs">Decline</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-else class="text-center py-5 bg-light rounded border border-dashed">
                        <p class="text-muted small mb-0">No pending requests.</p>
                      </div>


                    </div>



                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div v-if="show_catalogue" class="col-12" :class="isOwner ? 'col-xl-9' : 'col-12'">
          <div class="card border shadow rounded p-3 p-xl-4 mb-4 bg-light animate-up">

            <div class="d-flex flex-column flex-xl-row justify-content-between align-items-start align-items-xl-center gap-2 mb-3">
              <p class="fw-bold text-dark mb-0 d-flex align-items-start text-start">
                Catalogue
              </p>
              <div v-if="same_profile()" class="d-flex flex-wrap gap-2">
                <button
                  v-if="catalogueTab === 'products' && catalogue_products.length"
                  class="btn btn-sm btn-primary text-xxs rounded"
                  type="button"
                  @click="open_catalogue_promo_code_manager"
                >
                  Catalogue Promo
                </button>
                <button v-if="catalogueTab === 'products'" class="btn btn-sm btn-primary text-xxs rounded" type="button" data-bs-toggle="modal"
                  data-bs-target="#addItemModal" @click="set_modal_type('product')">Add Product</button>
                <button v-if="catalogueTab === 'services'" class="btn btn-sm btn-primary text-xxs rounded" type="button" data-bs-toggle="modal"
                  data-bs-target="#addItemModal" @click="set_modal_type('service')">Add Service</button>
              </div>
            </div>
            <div class="d-flex align-items-center bg-white rounded shadow-sm border px-1 py-1">

    
          <button class="btn btn-sm me-2 tab-arrow" @click="scroll_catalogue_Tabs('left')" aria-label="Scroll left">
            <i class="bi bi-chevron-left"></i>
          </button>
            <div class="d-flex mb-1 overflow-auto text-nowrap" ref="tabsCatalogue">
              <button v-for="tab in ['products', 'services'].filter(t => t !== 'dropoff' || isOwner)" :key="tab"
                class="btn btn-link text-decoration-none px-4 py-2 fw-semibold border-0 rounded-0 text-xs shadow-none"
                :class="catalogueTab === tab ? 'text-dark border-bottom border-2 border-dark' : 'text-muted'"
                @click="catalogueTab = tab">
                {{ tab.charAt(0).toUpperCase() + tab.slice(1) }}
                <span v-if="tab !== 'dropoff'" class="badge rounded-pill ms-1 text-xxs"
                  :class="catalogueTab === tab ? 'bg-primary' : 'bg-primary bg-opacity-25'">
                  {{ tab === 'products' ? catalogue_products.length : catalogue_services.length }}
                </span>
              </button>

              <button v-if="isOwner" class="btn btn-link text-decoration-none px-3 py-2 fw-semibold border-0 rounded-0 text-xs d-xl-none shadow-none"
                :class="catalogueTab === 'orders' ? 'text-dark border-bottom border-2 border-dark' : 'text-muted'"
                @click="catalogueTab = 'orders'; sidebarTab = 'orders'">
                Orders <span class="badge rounded-pill bg-primary ms-1 text-xxs">{{ pending_orders.length }}</span>
              </button>
              <button v-if="isOwner" class="btn btn-link text-decoration-none px-3 py-2 fw-semibold border-0 rounded-0 text-xs d-xl-none shadow-none"
                :class="catalogueTab === 'requests' ? 'text-dark border-bottom border-2 border-dark' : 'text-muted'"
                @click="catalogueTab = 'requests'; sidebarTab = 'requests'">
                Requests <span class="badge rounded-pill bg-primary ms-1 text-xxs">{{ pending_requests.length }}</span>
              </button>
            </div>
            <!-- Right Arrow -->
          <button class="btn btn-sm ms-2 tab-arrow" @click="scroll_catalogue_Tabs('right')" aria-label="Scroll right">
            <i class="bi bi-chevron-right"></i>
          </button></div>

            <div v-if="is_loading_products" class="d-flex justify-content-center align-items-center py-5 my-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else-if="(catalogueTab === 'products' || catalogueTab === 'services') && catalogue_items.length > 0" class="row overflow-auto scrollable-container py-2 g-1 pb-extra" >
             <div class="col-6 col-xl-2 mb-1" v-for="product in catalogue_items" :key="product.id">
                <div class="card h-100 shadow rounded border-1 pointer" @click="view_product_details(product)">
                  <div class="ratio ratio-1x1 rounded">
                    <img :src="product.images.length ? product.images[0].image_url : require('@/assets/images/image_placeholder.jpg')" class="marketplace-card-image" alt="Product Image">
                  </div>
                  <div v-if="!isOwner" class="position-absolute top-0 end-0 m-2">
                    <button v-if="product?.product_type?.name.toLowerCase() !=='service'"
                      class="btn btn-sm btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center marketplace-card-icon-btn"
                      @click.stop="add_to_cart(product.id, product.base_profile.id)"
                      title="Add to cart"
                    >
                      <i class="bi bi-cart-plus text-primary"></i>
                    </button>
                    <i  v-else
                      class="bi text-primary  rounded-circle shadow-sm d-flex align-items-center justify-content-center marketplace-card-icon-btn bg-light" 
                      :class="product.service_details?.type_name === 'drop_in' ? 'bi-shop' : 'bi bi-truck'"
                      :title="product.service_details?.type_name === 'drop_in' ? 'Drop-In Service' : 'Field Service'">
                    </i>
                  </div>
                  <div class="card-body d-flex flex-column p-2">
                    <h6 class="text-xs mb-1 fw-bold truncate-text">{{ product.name }}</h6>
                    <p class="text-muted text-xs mb-1">R{{ format_price(display_price(product)) }}</p>
                    <p v-if="product?.service_details?.location" class="text-xs text-muted mb-1">
                        <span>{{ product?.service_details?.location }}</span>
                      </p>
                    <div class="d-flex align-items-center mb-1 d-none">
                      <div class="d-flex">
                        <span v-for="n in 5" :key="n">
                          <i class="bi" :class="n <= product.average_rating ? 'bi-star-fill text-warning' : 'bi-star text-muted'"></i>
                        </span>
                      </div>
                      <span class="text-xxs text-muted ms-1">{{ product?.average_rating || '0' }}</span>
                      <span class="text-xxs text-muted ms-1">({{ product.total_reviews ?? 0 }})</span>
                    </div>
                    <div class="mt-auto">
                      <div v-if="isOwner" class="d-flex flex-wrap gap-1">
                        <button class="btn btn-primary rounded text-xxs py-1 px-2 flex-fill" @click.stop="toggle_publish(product)">
                          {{ product.is_published ? 'Unpublish' : 'Publish' }}
                        </button>
                        <button class="btn btn-secondary rounded text-xxs py-1 px-2 flex-fill" data-bs-toggle="modal" data-bs-target="#manageProductModal" @click.stop="open_manage_modal(product)">
                          Manage
                        </button>
                      </div>
                      <button v-else class="btn btn-primary w-100 rounded py-1 text-xxs" @click.stop="catalogueTab === 'services' ? open_service_request_modal(product) : add_to_cart(product.id, product.base_profile.id)">
                        {{ catalogueTab === 'services' ? 'Request Service' : 'Add to Cart' }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="catalogueTab === 'dropoff'">
              <Delivery :base_profile_id="companyData?.base_profile?.id" />
            </div>

            <div v-else-if="catalogueTab === 'orders'" class="d-xl-none  overflow-auto scrollable-container py-3 pb-5">
              <div v-if="pending_orders.length === 0" class="text-center py-3">
                <i class="bi bi-inbox text-muted display-6"></i>
                <p class="text-muted text-xs mt-2 mb-0">No pending orders</p>
              </div>
              <div v-for="order in pending_orders.slice(0, 3)" :key="order.id" class="card border-2 shadow-sm bg-light rounded p-3 mb-2" @click="view_all_orders">
                <div class="d-flex align-items-center gap-2 mb-2">
                  <div class="avatar-sm rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center"><i class="bi bi-person text-primary text-xs"></i></div>
                  <div class="flex-fill overflow-hidden">
                    <p class="mb-0 fw-bold text-xs text-dark text-truncate">{{ order.buyer_name }}</p>
                    <small class="text-muted text-xxs">{{ order.items.length }} · R{{ format_price(order.total_amount) }}</small>
                  </div>
                </div>
                   <div class="d-flex align-items-center justify-content-between">
                      <small class="text-muted text-xxs">{{ format_date(order.created_at) }}</small>
                      <button class="btn btn-sm btn-primary text-xxs rounded" @click="view_all_orders">
                        View
                      </button>
                    </div>
      
              </div>
              <div v-if="pending_orders.length > 3" class="text-center mt-2">
                  <button class="btn btn-link text-primary text-xxs" @click="view_all_orders">
                    View All Orders
                  </button>
              </div>

            </div>

            <div v-else-if="catalogueTab === 'requests'" class="d-xl-none overflow-auto scrollable-container py-3 pb-extra">
              <div v-if="pending_requests.length === 0" class="text-center py-3">
                <i class="bi bi-telephone text-muted display-6"></i>
                <p class="text-muted text-xs mt-2 mb-0">No pending requests</p>
              </div>
              <div v-for="request in pending_requests" :key="request.id" class="card border-2 shadow-sm rounded p-3 mb-2 scrollable-container ">
                <div class="d-flex align-items-center gap-2 mb-2">
                  
                  <div class="flex-fill overflow-hidden">
                    <p class="mb-0 fw-bold text-xs text-dark text-truncate">{{ request?.requester?.user?.first_name + ' ' + request?.requester?.user?.last_name }}</p>
                    <small class="text-muted text-xxs text-truncate d-block">{{ request?.product?.name }}</small>
                  </div>
                  <span class="badge rounded-pill text-xxs"
                  :class="{'bg-warning text-dark': request.status.name.toLowerCase() === 'pending','bg-success': request.status.name.toLowerCase() === 'approved',
                  'bg-info': request.status.name.toLowerCase() === 'completed','bg-primary': request.status.name.toLowerCase() === 'cancelled',
                  'bg-secondary': request.status.name.toLowerCase() === 'confirmed','bg-danger': request.status.name.toLowerCase() === 'declined',
                  'bg-dark text-white': request.status.name.toLowerCase() === 'disputed'}"
                  >{{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}
                  </span>
                </div>
                <div class="bg-light rounded p-2 mb-2"><small class="text-muted text-xxs fst-italic">{{ request?.message }}</small></div>
                <div class="bg-light rounded p-2 mb-2">
                  <small class="d-block text-xxs fw-semibold mb-1">Contacts</small>
                  <small class="d-block text-muted text-xxs fst-italic">{{ request?.email }}</small>
                  <small class="d-block text-muted text-xxs fst-italic">{{ request?.contact_number }}</small>
                    <small class="d-block text-muted text-xxs fst-italic">{{ request?.location ? 'Location: ' + request?.location : 'Location: Not provided'}}</small>

                  <small class="text-muted text-xxs d-block mb-2">{{'Preferred Date: ' + format_date(request?.request_date) }}</small>
                </div>
                <div v-if="['approved', 'disputed'].includes(request?.status?.name.toLowerCase())" class="d-flex gap-1">
                    <button class="btn btn-sm btn-primary rounded flex-fill text-xxs" @click="update_request(request, 'complete',request.decline_reason)">Complete</button>
                  </div>
                <div v-if="request?.status?.name.toLowerCase() === 'pending'" class="d-flex gap-1">
                  <button class="btn btn-sm btn-primary rounded flex-fill text-xxs" @click="update_request(request, 'approve',request.decline_reason)">Accept</button>
                  <button class="btn btn-sm btn-secondary rounded flex-fill text-xxs" @click="request.show_decline = !request.show_decline">Decline</button>
                </div>
                <div v-if="request.show_decline" class="mt-2">
                  <textarea v-model="request.decline_reason" rows="2" class="form-control form-control-sm rounded mb-2 text-xxs" placeholder="Reason for declining..."></textarea>
                  <div class="d-flex gap-1">
                    <button class="btn btn-sm btn-danger rounded flex-fill text-xxs" @click="update_request(request, 'decline', request.decline_reason); request.show_decline = false">Submit</button>
                    <button class="btn btn-sm btn-light rounded flex-fill text-xxs" @click="request.show_decline = false; request.decline_reason = ''">Cancel</button>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="text-center py-5 my-5">
              <div class="mb-3"><i :class="catalogueTab === 'services' ? 'bi bi-tools' : 'bi bi-box-seam'" class="display-3 text-muted"></i></div>
              <p class="text-muted">{{ active_profile ? `You haven't added any ${catalogueTab} yet.` : `No ${catalogueTab}.` }}</p>
            </div>

          </div>
        </div>

        <div class="col-xl-3 d-none d-xl-block">
          <div v-if="show_catalogue && isOwner">
            <div class="card bg-transparent border rounded p-4 mb-4 animate-up">
              <div class="d-flex border-bottom mb-3">
                <button class="btn btn-link text-decoration-none px-3 py-1 fw-semibold border-0 rounded-0 text-xs shadow-none"
                  :class="sidebarTab === 'orders' ? 'text-dark border-bottom border-2 border-dark' : 'text-muted'"
                  @click="sidebarTab = 'orders'; catalogueTab = 'products'">
                  Orders <span class="badge rounded-pill ms-1 text-xxs" :class="sidebarTab === 'orders' ? 'bg-dark' : 'bg-primary bg-opacity-25 '">{{ pending_orders.length }}</span>
                </button>
                <button class="btn btn-link text-decoration-none px-3 py-1 fw-semibold border-0 rounded-0 text-xs shadow-none"
                  :class="sidebarTab === 'requests' ? 'text-dark border-bottom border-2 border-dark' : 'text-muted'"
                  @click="sidebarTab = 'requests'">
                  Requests
                  <span class="badge rounded-pill ms-1 text-xxs bg-dark">
                    {{ pending_requests.length }}
                  </span>
                </button>
              </div>

              <!-- Orders list -->
              <div v-if="sidebarTab === 'orders'" class="d-flex flex-column gap-3">
                <div v-if="pending_orders.length === 0" class="text-center py-3">
                  <i class="bi bi-inbox text-muted display-6"></i>
                  <p class="text-muted text-xs mt-2 mb-0">No pending orders</p>
                </div>
                <div v-for="order in pending_orders.slice(0, 3)" :key="order.id" class="card border-0 shadow bg-light rounded p-3 pointer" @click="view_all_orders" >
                  <div class="d-flex align-items-center gap-2 mb-2">
                    <div
                      class="avatar-sm rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center">
                      <i class="bi bi-person text-primary text-xs"></i>
                    </div>
                 <div class="flex-fill overflow-hidden">
                    <p class="mb-0 fw-bold text-xs text-dark text-truncate">{{ order.buyer_name }}</p>
                    <small class="text-muted text-xxs">{{ order.items.length }} items · R{{ format_price(order.total_amount) }}</small>

                    <!-- Date and View Button in same line -->
                    <div class="d-flex align-items-center justify-content-between">
                      <small class="text-muted text-xxs">{{ format_date(order.created_at) }}</small>
                      <button class="btn btn-sm btn-primary text-xxs rounded" @click="view_all_orders">
                        View
                      </button>
                    </div>
                  </div>
                  </div>
                </div>
                  <!-- Show link if more than 5 orders -->
                  <div v-if="pending_orders.length > 3" class="text-center mt-2">
                      <button class="btn btn-link text-primary text-xxs" @click="view_all_orders">
                        View All Orders
                      </button>
                  </div>
              </div>

              <div v-if="sidebarTab === 'requests'" class="d-flex flex-column gap-3 overflow-auto scrollable-container">
                <div v-if="pending_requests.length === 0" class="text-center py-3"><i class="bi bi-telephone text-muted display-6"></i><p class="text-muted text-xs mt-2 mb-0">No pending requests</p></div>
                <div v-for="request in pending_requests" :key="request.id" class="card border-0 shadow-sm rounded p-3">
                  <div class="d-flex align-items-center gap-2 mb-2">
                    
                    <div class="flex-fill overflow-hidden"><p class="mb-0 fw-bold text-xs text-dark text-truncate">{{ request?.requester?.user?.first_name + ' ' + request?.requester?.user?.last_name }}</p><small class="text-muted text-xxs text-truncate d-block">{{ request?.product?.name }}</small></div>
                    <span class="badge rounded-pill text-xxs"
                    :class="{'bg-warning text-dark': request.status.name.toLowerCase() === 'pending','bg-success': request.status.name.toLowerCase() === 'approved',
                    'bg-info': request.status.name.toLowerCase() === 'completed','bg-primary': request.status.name.toLowerCase() === 'cancelled',
                    'bg-secondary': request.status.name.toLowerCase() === 'confirmed','bg-danger': request.status.name.toLowerCase() === 'declined',
                    'bg-dark text-white': request.status.name.toLowerCase() === 'disputed'}">
                      {{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}</span>
                  </div>
                  <div class="bg-light rounded p-2 mb-2"><small class="text-muted text-xxs fst-italic">{{ request?.message }}</small></div>
                  <div class="bg-light rounded p-2 mb-2">
                    <small class="d-block text-xxs fw-semibold mb-1">Contacts</small>
                    <small class="d-block text-muted text-xxs fst-italic">{{ request?.email }}</small>
                    <small class="d-block text-muted text-xxs fst-italic">{{ request?.contact_number }}</small>
                    <small class="d-block text-muted text-xxs fst-italic">{{ request?.location ? 'Location: ' + request?.location : 'Location: Not provided'}}</small>
                    <small class="text-muted text-xxs d-block mb-2">{{'Preferred Date: ' + format_date(request?.request_date) }}</small>
                  </div>
                  <div v-if="request?.status?.name.toLowerCase() === 'pending'" class="d-flex gap-1">
                    <button class="btn btn-sm btn-primary rounded flex-fill text-xxs" @click="update_request(request, 'approve',request.decline_reason)">Accept</button>
                    <button class="btn btn-sm btn-secondary rounded flex-fill text-xxs" @click="request.show_decline = !request.show_decline">Decline</button>
                  </div>
                  <div v-if="request.show_decline" class="mt-2">
                  <textarea v-model="request.decline_reason" rows="2" class="form-control form-control-sm rounded mb-2 text-xxs" placeholder="Reason for declining..."></textarea>
                  <div class="d-flex gap-1">
                    <button class="btn btn-sm btn-danger rounded flex-fill text-xxs" @click="update_request(request, 'decline', request.decline_reason); request.show_decline = false">Submit</button>
                    <button class="btn btn-sm btn-light rounded flex-fill text-xxs" @click="request.show_decline = false; request.decline_reason = ''">Cancel</button>
                  </div>
                </div>
                  <div v-if="['approved', 'disputed'].includes(request?.status?.name.toLowerCase())" class="d-flex gap-1">
                    <button class="btn btn-sm btn-primary rounded flex-fill text-xxs" @click="update_request(request, 'complete',request.decline_reason)">Complete</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!show_catalogue">
            <div class="bg-transparent p-2 rounded animate-up">

              <div class="d-flex align-items-center bg-light border-5 rounded shadow-sm p-3 mb-1">
                <i class="bi bi-star-fill text-warning me-2"></i>
                <h6 class="fw-bold text-dark mb-0">Ratings & Reviews</h6>
              </div>

              <div class="card border-0 bg-light border rounded shadow p-2 p-lg-4 mb-2 mb-lg-2">
                <div class="row align-items-center g-3">
                  <div class="col-4 col-lg-3 text-center">
                        <h2 class="fw-bold text-dark lh-1 mb-1">{{ rating || '0' }}</h2>
                        
                        <div class="text-warning mb-1 p-1 d-flex flex-nowrap justify-content-center">
                          <span v-for="n in 5" :key="n">
                            <i class="bi" :class="n <= rating ? 'bi-star-fill' : 'bi-star'"></i>
                          </span>
                        </div>
                        
                        <div class="text-muted text-nowrap text-xs">{{ total_ratings }} reviews</div>
                      </div>

                  <div class="col-8 col-lg-9 lg-4">
                    <div v-for="star in [5,4,3,2,1]" :key="star" class="d-flex align-items-center gap-2 mb-1 mb-lg-2 ">
                      <span class="text-muted text-xxs ms">{{ star }} ★</span>
                      <div class="progress flex-grow-1 rounded-pill ">
                        <div class="progress-bar bg-warning" :style="{ width: get_percentage(star) + '%' }"></div>
                      </div>
                      <span class="text-muted text-xxs">{{ get_percentage(star) }}%</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="!user_has_rated && !isOwner"
                class="card border bg-light rounded-5 shadow p-3 p-lg-4 mb-3 mb-lg-4">
                <h6 class="fw-bold text-dark mb-1 d-flex align-items-center gap-2">
                  <i class="bi bi-pencil-square text-primary"></i> Rate this Business
                </h6>
                <p class="text-muted small mb-2 mb-lg-3">How was your overall experience with this business?</p>

                <div class="d-flex align-items-center gap-1 mb-1 mb-lg-2">
                  <i v-for="n in 5" :key="n" class="pointer"
                    :class="n <= (hover_rating || new_rating) ? 'bi bi-star-fill text-warning' : 'bi bi-star text-secondary'"
                    @mouseenter="hover_rating = n" @mouseleave="hover_rating = 0" @click="new_rating = n">
                  </i>
                </div>

                <p class="text-muted small mb-2 mb-lg-3">{{ rating_level }}</p>
                <textarea v-model="new_review_text" class="form-control form-control-sm mb-3 rounded" rows="5"
                  placeholder="Share your thoughts — quality, communication, reliability..."></textarea>

                <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div class="d-flex align-items-center gap-2">
                    <label class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 d-none"
                      for="tabPhotoInput">
                      <i class="bi bi-camera"></i> <span class="d-none d-sm-inline">Add Photos</span>
                      <input type="file" id="tabPhotoInput" accept="image/*" multiple class="d-none"
                        @change="previewPhotos">
                    </label>
                    <div class="d-flex gap-1">
                      <img v-for="(src, i) in photoPreviews" :key="i" :src="src"
                        class="rounded border object-fit-cover">
                    </div>
                  </div>
                  <button class="btn btn-primary btn-sm fw-semibold rounded"
                    :disabled="!new_rating || !new_review_text.trim()" @click="submit_rating">
                    Submit Review
                  </button>
                </div>
              </div>

              <div class="scrollable-container py-3">
                <div v-for="item in all_ratings" :key="item.id"
                  class="card border bg-light rounded shadow-sm p-3 p-lg-4 mb-2">
                  <div class="d-flex gap-2 gap-lg-3 border p-1 rounded">

                    <img :src="get_active_profile_picture(item.rater) || require('@/assets/images/user.png')" alt="Rater Avatar"
                      class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0" />
                    <div class="flex-grow-1 min-w-0">
                      <div class="d-flex align-items-start justify-content-between mb-1">
                        <div class="d-flex flex-column pointer">
                          <div class="d-flex align-items-center gap-2 flex-wrap">
                            <span v-if="item?.rater?.profile_type?.toLowerCase().trim() === 'personal'"
                              @click="view_rater_profile(item?.rater?.user?.id)">
                              {{ item?.rater?.user?.first_name }} {{ item?.rater.base_profile?.user?.last_name }}
                            </span>
                            <span v-else @click="view_company(item?.rater)">
                              {{ item?.rater?.company?.company_name || 'Company Name' }}
                            </span>
                            <span v-if="String(item.rater?.id) === String(active_profile_data.id)"
                              class="badge rounded-pill text-primary bg-primary-subtle border border-primary-subtle">You</span>
                          </div>
                          <span class="text-muted text-xxs">{{ format_date(item.date_created) }}</span>
                        </div>

                        <div v-if="String(item.rater?.id) === String(active_profile_data.id)" class="dropdown">
                          <button class="btn btn-sm btn-link text-muted p-0 lh-1 shadow-none" data-bs-toggle="dropdown">
                            <i class="bi bi-three-dots"></i>
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3">
                            <li><a class="dropdown-item small d-flex align-items-center gap-2" href="#"
                                @click.prevent="open_edit_reviews(item)"><i class="bi bi-pencil text-muted"></i> Edit
                                Review</a></li>
                            <li>
                              <hr class="dropdown-divider my-1">
                            </li>
                            <li><a class="dropdown-item small d-flex align-items-center gap-2 text-danger" href="#"
                                @click.prevent="delete_review(item)"><i class="bi bi-trash"></i> Delete</a></li>
                          </ul>
                        </div>
                      </div>

                      <div class="mb-1 mb-lg-2">
                        <i v-for="n in 5" :key="n"
                          :class="n <= item.rating ? 'bi-star-fill text-warning' : 'bi-star text-secondary'"></i>
                      </div>

                      <p class="text-primary mb-2">
                        {{ item.expanded ? item.comment : item.comment.slice(0, 120) + (item.comment.length > 120 ?
                        '...' : '') }}
                        <span v-if="item.comment.length > 120"
                          class="text-decoration-underline pointer ms-1 small fw-semibold text-secondary"
                          @click="item.expanded = !item.expanded">
                          {{ item.expanded ? 'Show less' : 'Read more' }}
                        </span>
                      </p>

                      <!-- ── REPLIES ── -->
                      <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                        <button class="btn btn-link btn-sm text-primary p-0 shadow-none text-decoration-none text-xxs"
                          @click="item.show_replies = !item.show_replies">
                          <i class="bi bi-chat me-1"></i>
                          Reply<span v-if="item.replies && item.replies.length"> ({{ item.replies.length }})</span>
                        </button>
                      </div>

                      <div v-if="item.show_replies" class="mt-2 ps-2 border-start border-2">

                        <!-- Existing replies -->
                        <div v-for="reply in item.replies" :key="reply.id" class="d-flex gap-2 mb-2">
                          <img :src="get_active_profile_picture(reply.commenter)" alt="Reply Avatar"
                            class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0" />
                          <div class="flex-grow-1">
                            <div class="rounded p-2 px-3"
                              :class="reply.is_owner ? 'bg-primary-subtle border border-primary-subtle' : 'bg-white border'">
                              <div class="d-flex align-items-center gap-2 mb-1 text-xxs fw-bold">

                                <span v-if="reply.commenter.profile_type?.toLowerCase().trim() === 'personal'"
                                  @click="view_profile(reply?.commenter?.user?.id)">
                                  {{ reply?.commenter?.user?.first_name }} {{ reply?.commenter?.user?.last_name }}
                                </span>
                                <span v-else @click="view_company(report?.commenter)">
                                  {{ reply?.commenter?.company?.company_name || 'Company Name' }}
                                </span>
                                <span v-if="reply.is_owner" class="badge bg-primary rounded-pill">Owner</span>
                              </div>
                              <p class="mb-0 text-primary text-xxs">{{ reply.comment }}</p>
                            </div>
                            <span class="text-muted ms-2 text-xxs">{{ reply.created_at }}</span>
                          </div>
                        </div>

                        <!-- Reply input -->
                        <div class="d-flex gap-2 mt-2 align-items-center">
                          <input v-model="item.reply_draft" type="text"
                            class="form-control form-control-sm rounded-pill" placeholder="Write a reply…"
                            @keyup.enter="submit_reply(item)">
                          <button class="btn btn-primary btn-sm rounded-pill px-3 fw-semibold flex-shrink-0"
                            @click="submit_reply(item)">
                            Send
                          </button>
                        </div>

                      </div>
                      <!-- ── END REPLIES ── -->

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
  <div class="modal fade" id="view_answer_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content border-0 rounded">

        <div class="modal-header border-0">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-0 ">
          <div v-if="is_image_file(answer_file_name)">
            <img :src="image_view_url" alt="Image" class="img-fluid rounded mx-auto d-block" />
          </div>
          <div v-else-if="is_pdf_file(answer_file_name)">
            <iframe :src="image_view_url" class="w-100" height="600" frameborder="0"></iframe>
          </div>
          <div v-else-if="is_office_file(answer_file_name)">
            <iframe :src="`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(image_view_url)}`"
              class="w-100" height="600" frameborder="0"></iframe>
          </div>

          <div v-else>
            <div class="p-4 text-center">
              <p class="fw-semibold mb-2">{{ answer_file_name }}</p>
              <p class="text-muted mb-3">
                Preview not available for this file type.
              </p>
              <a :href="image_view_url" target="_blank" class="btn btn-primary rounded">
                Download File
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <teleport to="body">
    <div class="modal fade" id="image_view_modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content shadow scrollable-container">
          <div class="modal-header bg-primary position-relative">
            <p class="modal-title text-white text-xxs" id="image_view_modal">Business Profile</p>
            <button type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <div class="modal-body text-center p-2">
            <div v-if="profile_picture_preview">
              <img :src="profile_picture_preview" class="rounded w-100 shadow-sm border" />
            </div>
            <div v-else>
              <img :src="image_view_url" alt="Image" class="rounded w-100 shadow-sm borde" />
            </div>
          </div>

          <!-- <div class="modal-body modal-body-scroll p-0">
            <img :src="image_view_url" alt="Image" class="img-fluid rounded-4 d-block image-preview" />
            <i v-if="isOwner"
              class="bi bi-camera text-primary position-absolute top-0 end-0 m-3 bg-white p-1 rounded-circle"
              @click="triggerProfileFileUpload"></i>
          </div> -->

          <div v-if="isOwner" class="modal-footer border-0 p-3 d-flex justify-content-end gap-2">

            <!-- If there is a preview, show full-width Save button -->
            <button v-if="profile_picture_preview" class="btn btn-sm btn-primary text-xs rounded w-100 py-2"
              @click="upload_profile_picture('logo')">
              Upload
            </button>

            <!-- If no preview, show Upload and Delete side by side -->
            <div v-else class="d-flex gap-2">
              <button class="btn btn-sm btn-primary rounded text-xxs flex-fill py-2 " @click="triggerProfileFileUpload">
                Upload
              </button>
              <button class="btn btn-sm btn-primary text-xxs rounded flex-fill py-2 "
                @click="delete_cover_image('logo')">
                Delete
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
    


  </teleport>
  <teleport to="body">
  <div id="ratings_modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
      <div class="modal-content rounded-5 shadow border-0">

        <div class="modal-header bg-primary position-relative border-0 p-3">
          <h5 class="modal-title text-white fw-bold text-sm">Ratings & Reviews</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-3 p-md-4 bg-transparent">
          
          <div class="card border-0 bg-light rounded shadow-sm p-3 p-lg-4 mb-4">
            <div class="row align-items-center g-3">
              <div class="col-4 col-lg-3 text-center border-end">
                <h2 class="fw-bold text-dark lh-1 mb-1">{{ rating || '0.0' }}</h2>
                <div class="text-warning mb-1 p-1">
                  <span v-for="n in 5" :key="n">
                    <i class="bi" :class="n <= rating ? 'bi-star-fill' : 'bi-star'"></i>
                  </span>
                </div>
                <div class="text-muted text-xxs fw-bold">{{ total_ratings }} reviews</div>
              </div>
              <div class="col-8 col-lg-9">
                <div v-for="star in [5,4,3,2,1]" :key="star" class="d-flex align-items-center gap-2 mb-1">
                  <span class="text-muted text-xxs fw-bold" >{{ star }} ★</span>
                  <div class="progress flex-grow-1 rounded">
                    <div class="progress-bar bg-warning" :style="{ width: get_percentage(star) + '%' }"></div>
                  </div>
                  <span class="text-muted text-xxs">{{ get_percentage(star) }}%</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="(!user_has_rated && !isOwner) || is_editing_review" 
               class="card border-0 bg-light rounded-5 shadow-sm p-3 p-lg-4 mb-4 border border-primary border-opacity-10">
            <h6 class="fw-bold text-dark mb-1 d-flex align-items-center gap-2 small">
              <i class="bi" :class="is_editing_review ? 'bi-pencil-square' : 'bi-plus-circle'"></i>
              {{ is_editing_review ? 'Edit Your Review' : 'Rate this Business' }}
            </h6>
            
            <div class="d-flex align-items-center gap-1 mb-2">
              <i v-for="n in 5" :key="n" class="pointer fs-5"
                :class="n <= (hover_rating || new_rating) ? 'bi bi-star-fill text-warning' : 'bi bi-star text-secondary'"
                @mouseenter="hover_rating = n" @mouseleave="hover_rating = 0" @click="new_rating = n">
              </i>
            </div>
            
            <p class="text-muted small mb-2">{{ rating_level }}</p>

            <textarea v-model="new_review_text" 
                      class="form-control mb-3 rounded-3 border-0 shadow-xs text-xs" 
                      rows="4" 
                      placeholder="Share your thoughts...">
            </textarea>

            <div class="d-flex gap-2">
                <button v-if="is_editing_review" class="btn btn-secondary btn-sm flex-fill rounded-pill" @click="cancel_edit_review">Cancel</button>
                <button class="btn btn-primary btn-sm flex-fill rounded-pill shadow-sm" 
                        @click="submit_rating" 
                        :disabled="!new_rating || !new_review_text.trim()">
                  {{ is_editing_review ? 'Update Review' : 'Submit Review' }}
                </button>
            </div>
          </div>

          <div class="scrollable-reviews">
            <div v-for="item in all_ratings" :key="item.id" class="card border bg-light rounded shadow-sm p-3 p-lg-4 mb-3">
              <div class="d-flex gap-3">
                <img :src="get_active_profile_picture(item.rater) || require('@/assets/images/user.png')" 
                     class="profile-image rounded-5 profile-list-avatar flex-shrink-0" />
                
                <div class="flex-grow-1 min-w-0">
                  <div class="d-flex align-items-start justify-content-between mb-1">
                    <div class="d-flex flex-column">
                      <span class="fw-bold text-xs pointer" @click="item?.rater?.profile_type === 'personal' ? view_rater_profile(item?.rater?.user?.id) : view_company(item?.rater)">
                        {{ item?.rater?.profile_type === 'personal' ? (item?.rater?.user?.first_name + ' ' + item?.rater?.user?.last_name) : item?.rater?.company?.company_name }}
                      </span>
                      <span class="text-muted text-xxs">{{ format_date(item.date_created) }}</span>
                    </div>

                    <div v-if="String(item.rater?.id) === String(active_profile_data.id)" class="dropdown">
                      <button class="btn btn-sm btn-link text-muted p-0 shadow-none" data-bs-toggle="dropdown">
                        <i class="bi bi-three-dots"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3">
                        <li><a class="dropdown-item small" href="#" @click.prevent="open_edit_reviews(item)">Edit</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item small text-danger" href="#" @click.prevent="delete_review(item)">Delete</a></li>
                      </ul>
                    </div>
                  </div>

                  <div class="mb-2">
                    <i v-for="n in 5" :key="n" :class="n <= item.rating ? 'bi-star-fill text-warning' : 'bi-star text-secondary'"></i>
                  </div>

                  <p class="text-dark text-xxs mb-2 lh-base">
                    {{ item.expanded ? item.comment : item.comment.slice(0, 120) + (item.comment.length > 120 ? '...' : '') }}
                    <span v-if="item.comment.length > 120" class="text-decoration-underline pointer small fw-bold text-primary" @click="item.expanded = !item.expanded">
                      {{ item.expanded ? 'Show less' : 'Read more' }}
                    </span>
                  </p>

                  <div class="d-flex align-items-center gap-2 mb-1">
                    <button class="btn btn-link btn-sm text-primary p-0 text-decoration-none text-xxs fw-bold" @click="item.show_replies = !item.show_replies">
                      <i class="bi bi-chat me-1"></i> Reply ({{ item.replies?.length || 0 }})
                    </button>
                  </div>

                  <div v-if="item.show_replies" class="mt-2 ps-2 border-start border-2 border-primary">
                    <div v-for="reply in item.replies" :key="reply.id" class="d-flex gap-2 mb-2">
                      <div class="flex-grow-1 bg-white border p-2 rounded-3 shadow-xs">
                        <div class="d-flex align-items-center gap-2 mb-1 text-xxs fw-bold">
                          <span>{{ reply?.commenter?.user?.first_name }}</span>
                          <span v-if="reply.is_owner" class="badge bg-primary rounded-pill">Owner</span>
                        </div>
                        <p class="mb-0 text-muted text-xxs">{{ reply.comment }}</p>
                      </div>
                    </div>
                    <div class="d-flex gap-2 mt-2">
                      <input v-model="item.reply_draft" type="text" class="form-control form-control-sm rounded-pill text-xxs bg-light border-0" placeholder="Write a reply..." @keyup.enter="submit_reply(item)">
                      <button class="btn btn-primary btn-sm rounded-pill px-3" @click="submit_reply(item)">Send</button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</teleport>

  <teleport to="body">
    <div class="modal fade" id="image_preview_modal" tabindex="-1" aria-labelledby="image_preview_modal_label"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded shadow scrollable-container">
          <div class="modal-header border-0 pb-0">
            <p class="modal-title fw-bold text-black">Profile Image</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>

          </div>

          <div class="modal-body text-center p-2">
            <div v-if="profile_picture_preview">
              <img :src="profile_picture_preview" class="rounded w-100 shadow-sm border" />
            </div>
            <div v-else>
              <img :src="image_view_url" alt="Image" class="rounded w-100 shadow-sm borde" />
            </div>
          </div>
          <div v-if="isOwner" class="modal-footer border-0 p-3 d-flex justify-content-end gap-2">

            <!-- If there is a preview, show full-width Save button -->
            <button v-if="profile_picture_preview" class="btn btn-sm btn-primary text-xs rounded w-100 py-2"
              @click="upload_profile_picture('logo')">
              Upload
            </button>

            <!-- If no preview, show Upload and Delete side by side -->
            <div v-else class="d-flex gap-2">
              <button class="btn btn-sm btn-primary rounded text-xxs flex-fill py-2 " @click="triggerProfileFileUpload">
                Upload
              </button>
              <button class="btn btn-sm btn-primary text-xxs rounded flex-fill py-2 "
                @click="delete_cover_image('logo')">
                Delete
              </button>
            </div>

          </div>
          <!-- <div class="modal-footer">
        <button class="btn btn-primary btn-sm text-xxs rounded" @click="upload_profile_picture('logo')">Save</button>
      </div> -->
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade shadow-lg" id="cover_picture_modal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded border-0">
          <div class="modal-header border-0 pb-0">
            <p class="modal-title fw-bold text-black">Banner Image</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div class="modal-body text-center p-2">
            <div v-if="profile_picture_preview">
              <img :src="profile_picture_preview" class="rounded w-100 shadow-sm border" />
            </div>
            <div v-else>
              <img :src="image_view_url" alt="Image" class="rounded w-100 shadow-sm border" />
            </div>
          </div>
          <!-- Bottom-left buttons container -->
          <div v-if="isOwner" class="modal-footer border-0 p-3 d-flex justify-content-end gap-2">

            <!-- If there is a preview, show full-width Save button -->
            <button v-if="profile_picture_preview" class="btn btn-sm btn-primary text-xs rounded w-100 py-2"
              @click="upload_profile_picture('cover_picture')">
              Upload
            </button>

            <!-- If no preview, show Upload and Delete side by side -->
            <div v-else class="d-flex gap-2">
              <button class="btn btn-sm btn-primary rounded text-xxs flex-fill py-2 " @click="triggerProfileFileUpload">
                Upload
              </button>
              <button class="btn btn-sm btn-primary text-xxs rounded flex-fill py-2 "
                @click="delete_cover_image('cover_picture')">
                Delete
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </teleport>


  <teleport to="body">
    <div class="modal fade" id="edit_report_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content rounded-5 shadow scrollable-container">
          <div class="modal-header bg-primary position-relative">
            <h5 class="modal-title text-white" id="exampleModalLabel">Edit your feed</h5>
            <button type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent="edit_report_data">
            <div class="modal-body">
              <div class="d-flex align-items-center mb-3">
                <label for="toggle-comments" class="form-label mb-0 me-3 text-xs fw-500">Allow comments:</label>
                <div class="form-check form-switch ">
                  <input class="form-check-input" type="checkbox" id="toggle-comments" v-model="comments_off">
                  <label class="form-check-label" for="toggle-comments ms-2">{{ comments_off ? 'Yes' : 'No' }}</label>
                </div>
              </div>
              <QuillEditor theme="snow" v-model="report_description" ref="quillReportRef" class="quill-editor"
                toolbar="full" />
              <div class="d-flex mt-2 mx-1 justify-content-between align-items-start">
                <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
                  <label for="editReportFileInput"
                    class="text-xxs text-secondary fw-500 border-0 rounded btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                    <i class='bx bx-image-add file-upload-icon'></i> Add Feed content
                  </label>
                  <input type="file" id="editReportFileInput" class="file-input d-none"
                    @change="handleHomeFilterFileUpload" />
                  <div v-if="editFileName" class="text-xxs text-secondary fst-italic mt-1">
                    <span class="fw-500">File name:</span> {{ editFileName }}
                  </div>
                  <div v-if="fileError" class="text-xxs text-danger fst-italic mt-1">{{ fileError }}</div>
                </div>
                <div class="file-upload ms-5 my-2 mx-3 flex-grow-1 d-flex flex-column align-items-center">
                  <label for="audioInput"
                    class="text-xxs text-secondary fw-500 border-0 rounded btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                    <i class='bx bx-music'></i> Upload Audio
                  </label>
                  <input type="file" accept="audio/*" id="audioInput" class="file-input d-none"
                    @change="handleAudioUpload" />
                  <div v-if="audioError" class="text-xxs text-danger fst-italic mt-1">{{ audioError }}</div>
                </div>
                <div class="d-flex flex-column align-items-center my-2 flex-grow-1">
                  <div class="d-flex flex-row align-items-center mb-3">
                    <button type="button"
                      class="btn btn-light text-xxs text-secondary rounded-5 mx-2 d-flex align-items-center justify-content-center"
                      @click="startRecording" v-if="!isRecording">
                      <i class='bx bx-microphone'></i> Record
                    </button>
                    <button type="button"
                      class="btn btn-danger text-xxs rounded mx-2 d-flex align-items-center justify-content-center"
                      @click="stopRecording" v-if="isRecording">
                      <i class='bx bx-stop'></i> Stop
                    </button>
                  </div>
                  <div v-if="audio_file_name" class="text-xxs text-secondary fw-500 mb-3 audio-file">
                    <i class='bx bx-music'></i> Recorded: {{ audio_file_name }}
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column" v-if="edit_documents.report_files && edit_documents.report_files.length">
                <div class="row g-3">
                  <div v-for="(fileObj, index) in edit_documents.report_files" :key="index" class="col-4  mb-3">

                    <!-- Image -->
                    <img
                      v-if="fileObj.file.file_url.includes('.jpg') || fileObj.file.file_url.includes('.png') || fileObj.file.file_url.includes('.jpeg')"
                      :src="fileObj.file.file_url" alt="Feed Image" class="img-fluid rounded w-100 h-50"
                      :class="{ 'zoomed-in': isZoomed }" @click="display_comment_modal(report)" ref="image" />

                    <!-- Audio -->
                    <audio v-else-if="fileObj.file.file_url.includes('.mp3') || fileObj.file.file_url.includes('.wav')"
                      controls class="w-100 rounded">
                      <source :src="fileObj.file.file_url" type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>

                    <!-- Video -->
                    <video v-else-if="/\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.file_url)" controls class="img-fluid rounded w-100">
                      <source :src="fileObj.file.file_url" />
                      Your browser does not support the video tag.
                    </video>

                    <!-- PDF -->
                    <iframe v-else-if="fileObj.file.file_url.includes('.pdf')"
                      :src="'https://docs.google.com/viewer?url=' + encodeURIComponent(fileObj.file.file_url) + '&embedded=true'"
                      frameborder="0" width="100%" height="500px">
                    </iframe>

                    <!-- Word Document -->
                    <iframe
                      v-else-if="fileObj.file.file_url.includes('.docx') || fileObj.file.file_url.includes('.doc')"
                      :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                      class="img-fluid rounded w-100">
                    </iframe>

                    <!-- Excel Document -->
                    <iframe v-else-if="fileObj.file.file_url.includes('.xls') ||
                                      fileObj.file.file_url.includes('.xlsx') ||
                                      fileObj.file.file_url.includes('.xlsm') ||
                                      fileObj.file.file_url.includes('.xlsb')"
                      :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                      frameborder="0" width="100%" height="500px">
                    </iframe>

                    <!-- Zoom Button -->
                    <button v-if="!fileObj.file.file_url.includes('.mp3') &&
                                !fileObj.file.file_url.includes('.wav')" @click="toggleZoom"
                      class="zoom-btn btn btn-light position-absolute top-0 end-0 m-2 bg-transparent rounded">
                      <i :class="isZoomed ? 'bx bxs-zoom-out fs-6 text-white' : 'bx bxs-zoom-in fs-6 text-white'"></i>
                    </button>

                    <!-- Fullscreen Button -->
                    <button v-if="!fileObj.file.file_url.includes('.mp3') &&
                                !fileObj.file.file_url.includes('.wav')" @click="toggleFullscreen"
                      class="fullscreen-btn position-absolute btn btn-light top-0 start-0 m-2">
                      <i class="bi bi-arrows-fullscreen"></i>
                    </button>

                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary text-xxs rounded">Post</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <div class="modal fade" id="gallery_media_view_modal" tabindex="-1" aria-hidden="true"
      @hidden.bs.modal="selectedGalleryItem = null">
      <div class="modal-dialog modal-dialog-centered modal-lg ">
        <div class="modal-content border-0 shadow-lg rounded overflow-hidden">
          <div class="modal-header border-0 p-4 shadow-sm bg-primary">
            <h5 class="modal-title fw-500 text-sm text-white" v-if="selectedGalleryItem">
              {{ selectedGalleryItem.name }}
            </h5>
            <button type="button" class="btn-close bg-white" @click="close_gallery_media" aria-label="Close"></button>
          </div>

          <div class="modal-body  text-center d-flex flex-column align-items-center justify-content-center">
            <div v-if="selectedGalleryItem" class="w-100 d-flex align-items-center justify-content-center">

              <!-- Image View (including GIFs) -->
              <div v-if="selectedGalleryItem.type === 'image'" class="animate-up">
                <img :src="selectedGalleryItem.url" class="img-fluid rounded-3 shadow-sm border"
                  :alt="selectedGalleryItem.url">
              </div>

              <!-- Video View -->
              <div v-if="selectedGalleryItem.type === 'video'" class="w-100 animate-up">
                <div class="ratio ratio-16x9 rounded-3 overflow-hidden shadow-sm bg-black border">
                  <video id="gallery_video_player_modal" controls autoplay class="w-100 h-100">
                    <source :src="selectedGalleryItem.url" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </teleport>

  <CatalogueView :vm="catalogue_modal_context" />

  <ProductPromoCode
    ref="productPromoCodeRef"
    @promo-updated="update_parent_product_promos"
    @promo-deleted="handle_parent_product_promo_deletion"
  />

  <teleport to="body">
    <div class="modal fade" id="follower_modal" tabindex="-1" aria-labelledby="followersModalLeble" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content scrollable-container rounded">
          <div class="modal-header bg-primary position-relative">
            <h5 class="modal-title fw-bold text-white">{{ type_of_followers ? 'Followers' : 'Following' }}</h5>
            <button type="button" class="btn-close bg-light" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body modal-body-scroll p-4">

            <div v-if="loading_followers" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
            </div>

            <ul v-else-if="followers_list.length" class="list-group list-group-flush">
              <li v-for="follow in followers_list" :key="follow.id" class="list-group-item p-3 mb-2 border rounded">

                <div v-for="profile in [type_of_followers ? follow.follower : follow.target]" :key="profile.id"
                  class="d-flex align-items-center gap-3 w-100 pounter">

                  <div class="avatar-sm mb-1">
                  <img  
                        :src="get_active_profile_picture(profile) || require('@/assets/images/user.png')" 
                        class="rounded-circle border shadow-sm object-fit-cover" 
                        width="48" height="48"
                        alt="logo">
                </div>

                  <div>
                    <h6 v-if="profile?.profile_type == 'business'" class="mb-0 fw-bold ms-2 mt-2 " @click=view_company(profile)>
                      {{ profile?.company?.company_name }}
                    </h6>
                    <h6 v-else class="mb-0 fw-bold ms-2 mt-2 pointer" @click="view_rater_profile(profile?.user?.id)">
                      {{ profile?.user?.first_name }} {{ profile?.user?.last_name }}
                    </h6>
                  </div>

                </div>

              </li>
            </ul>

            <div v-else class="text-center p-5 text-muted">
              <i class="bi bi-people d-block mb-2 fs-2"></i>
              <p>{{ type_of_followers ? 'No followers found yet.' : 'No following found yet.' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade" id="likes_modal" tabindex="-1" aria-labelledby="likes_modal_label" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content border-0 shadow rounded-3">
          <div class="modal-header bg-primary text-white position-relative">
            <h5 class="modal-title fw-bold" id="likes_modal_label">
              <span class="mt-5">Likes</span>
            </h5>
            <button type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>

          <div class="modal-body pt-2">
            <ul class="list-group list-group-flush scrollable-container h-50px">
              <li v-for="user in modal_likes" :key="user.id"
                class="list-group-item d-flex align-items-center px-0 border-bottom">
                <!-- Profile image -->
                <div class="position-relative me-3">
                  <img v-if="user?.user?.profile_picture" :src="user?.user?.profile_picture"
                    class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0" alt="Profile Picture">
                  <i v-else class="bi bi-person-circle fs-4 text-dark pointer"></i>
                </div>

                <!-- Name & mutual friend -->
                <div class="fw-semibold">
                  <span v-if="user?.user?.is_blocked">Unknown User</span>
                  <span v-else @click="view_profile(user?.user.id)">
                    {{ user?.user.first_name }} {{ user?.user.last_name }}
                  </span>
                </div>
              </li>
            </ul>

            <p v-if="modal_likes.length === 0" class="text-muted text-center mt-3">
              No likes yet.
            </p>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <div class="modal fade" id="visibility_modal" tabindex="-1" aria-labelledby="visibilityModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-3 shadow border-0">
          <!-- Header -->
          <div class="modal-header border-bottom-0">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <!-- Body -->
          <div class="modal-body pb-0">
            <p class="mb-3 text-muted d-flex align-items-center gap-1">
              <i class="bi bi-info-circle"></i>
              Choose who can see this information on your profile.
            </p>

            <div class="form-check mb-3 p-3 rounded border bg-light d-flex align-items-start">
              <input class="form-check-input me-2 mt-1" type="radio" id="public" :value="true"
                v-model="currentVisibility" />
              <label class="form-check-label fw-medium" for="public">
                <i class="bx bx-globe me-1"></i> Public
                <div class="small text-muted">Anyone can see this field.</div>
              </label>
            </div>

            <div class="form-check p-3 rounded border bg-light d-flex align-items-start">
              <input class="form-check-input me-2 mt-1" type="radio" id="private" :value="false"
                v-model="currentVisibility" />
              <label class="form-check-label fw-medium" for="private">
                <i class="bx bxs-lock-alt me-1"></i> Only Me
                <div class="small text-muted">Only you can see this field.</div>
              </label>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer border-0 pt-0 mt-3">
            <button class="btn btn-secondary btn-sm text-xs shadow-sm d-flex align-items-center gap-1 mt-3"
              data-bs-dismiss="modal">
              Cancel
            </button>
            <button class="btn btn-primary btn-sm text-xs shadow-sm d-flex align-items-center gap-1 mt-3"
              @click="save_company_visibility">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Place this after your last modal (e.g. after #company_finance_modal or at the end of your file, but inside <section>) -->

    <!-- Dynamic Answer Visibility Modal -->
    <div class="modal fade" id="answer_visibility_modal" tabindex="-1" aria-labelledby="answerVisibilityModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-3 shadow border-0">

          <!-- Header -->
          <div class="modal-header border-bottom-0">
            <h5 class="modal-title" id="answerVisibilityModalLabel">Set Answer Visibility</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <!-- Body -->
          <div class="modal-body pb-0">
            <p class="mb-3 text-muted d-flex align-items-center gap-2">
              <i class="bi bi-info-circle"></i>
              Choose who can see this answer on your profile.
            </p>

            <div class="form-check mb-3 p-3 rounded border bg-light d-flex align-items-start">
              <input class="form-check-input me-2 mt-1" type="radio" id="answer_public" :value="true"
                v-model="currentAnswerVisibility" />
              <label class="form-check-label fw-medium" for="answer_public">
                <i class="bx bx-globe me-1"></i> Public
                <div class="small text-muted">Anyone can see this answer.</div>
              </label>
            </div>

            <div class="form-check p-3 rounded border bg-light d-flex align-items-start">
              <input class="form-check-input me-2 mt-1" type="radio" id="answer_private" :value="false"
                v-model="currentAnswerVisibility" />
              <label class="form-check-label fw-medium" for="answer_private">
                <i class="bx bxs-lock-alt me-1"></i> Only Me
                <div class="small text-muted">Only you can see this answer.</div>
              </label>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer border-0 pt-0 mt-3">
            <button class="btn btn-secondary btn-sm text-xs shadow-sm d-flex align-items-center gap-1 mt-3"
              data-bs-dismiss="modal">
              Cancel
            </button>
            <button class="btn btn-primary btn-sm text-xs shadow-sm d-flex align-items-center gap-1 mt-3"
              @click="save_answer_visibility">
              Save
            </button>
          </div>

        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade" id="social_modal" tabindex="-1" aria-labelledby="social_modal_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content shadow scrollable-container rounded">

          <div class="modal-header bg-primary position-relative">
            <h5 class="modal-title fw-bold text-white" id="social_modal_label">
              <span>Add Social Links</span>
            </h5>
            <button type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-3"
              data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>

          <div class="modal-body modal-body-scroll p-4">
            <label class="form-label fw-bold text-dark mb-3">Social Links</label>

            <div v-for="(link, index) in new_socials" :key="index" class="row g-2 align-items-center mb-3">
              <div class="col-12 col-md-4">
                <select v-model="link.platform" class="form-select rounded-3 bg-light">
                  <option value="" disabled>Select platform</option>
                  <option v-for="type in social_platforms" :key="type.id" :value="type.id">
                    {{ type.name }}
                  </option>
                </select>
              </div>

              <div class="col-10 col-md-7">
                <input type="url" v-model="link.url" class="form-control rounded bg-light"
                  placeholder="Enter profile link">
                <p v-if="errors.social_link" class="text-danger text-xxs">{{ errors.social_link }}</p>
              </div>

              <div class="col-2 col-md-1 text-end text-md-center">
                <i class="bi bi-trash text-danger fs-5 pointer" @click="remove_row(index)" title="Remove"></i>
              </div>
            </div>

            <button type="button" class="btn btn-secondary mt-1 rounded btn-sm" @click="add_social_row">
              <i class="bi bi-plus-circle me-1"></i>
              Add Social Link
            </button>
          </div>
          <div class="modal-footer border-0 pt-0 pb-4 px-4 d-flex justify-content-between">
            <button type="button" class="btn btn-light rounded px-4 fw-bold" data-bs-dismiss="modal">Cancel</button>

            <button type="button" class="btn btn-sm btn-primary rounded " @click="save_social_profiles">
              Save Links
            </button>
          </div>

        </div>
      </div>
    </div>
  </teleport>

<teleport to="body">
  <div class="modal fade" id="serviceRequestModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl ">
      <div class="modal-content shadow border-0 overflow-hidden rounded">
        <div class="modal-header bg-primary ">

          <button type="button" 
              class="btn-close bg-light rounded-circle" 
              data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>
       

        <div class="modal-body bg-light">
          <div class="row g-0">
            <div class="col-lg-5  p-md-2 bg-transparent">
              <img :src="service_request?.images?.[0]?.image_url || require('@/assets/images/image_placeholder.jpg')" 
                class="img-fluid rounded mb-3 rounded bg-transparent shadow" alt="Service Image">
              <div class="d-flex gap-2 p-2 bg-transparent border-rounded overflow-auto bg-danger">
              <img v-for="(image, index) in service_request.images" :key="index" :src="image.image_url"
                class="rounded object-fit-cover border-0 shadow pointer" width="100">
            </div>

              <h4 class="fw-bold text-dark mb-1 mt-3">{{ service_request?.name }}</h4>
              <p class="text-muted mb-2">Offered by <span class="fw-bold text-primary">{{ companyData?.company_name }}</span></p>
              <div class="mb-3">
            <div v-if="service_request?.service_details?.type_name === 'drop_in'" class="d-flex align-items-center gap-2 text-dark small">
              <i class="bi bi-geo-alt-fill text-primary"></i>
              <span><strong>Location:</strong> {{ service_request?.service_details.location }}</span>
            </div>

            <div v-else-if="service_request?.service_details?.type_name === 'on_site'" class="d-flex align-items-center gap-2 text-muted text-xs italic">
              <i class="bi bi-info-circle-fill text-info"></i>
              <span>Please provide the address where the service should be conducted in the form.</span>
            </div>
          </div>
              <h5 class="fw-bold text-dark mb-3">R{{ format_price(service_request?.price) }}</h5>
              
              <div class="text-muted text-xs lh-lg quill-content" v-html="service_request?.description"></div>
            </div>

            <div class="col-lg-7 p-md-1 bg-light ">
              <div class="card border-2 border-primary bg-white rounded shadow-sm p-3  d-flex flex-column py-5">
                
                <h6 class="text-center fw-bold text-dark mb-4">Request a Session</h6>

                <div class="mb-3 ">
                  <label class="small fw-bold text-dark mb-2 d-block ms-1">Preferred Date</label>
                  <input type="datetime-local" class="form-control border-1 border-primary rounded bg-light" 
                    v-model="service_request.date" :min="min_date">
                  <p v-if="errors.service_date" class="text-danger text-xxs mt-1 mb-0">{{ errors.service_date }}</p>
                </div>

                <div class="row mb-3 g-3">
                  <div class="col-md-6">
                    <label class="small fw-bold text-dark mb-2 d-block ms-1">Email Address</label>
                    <input type="email" class="form-control border-1 border-primary rounded bg-light" 
                      v-model="service_request.email" placeholder="your@email.com">
                  </div>
                  <div class="col-md-6">
                    <label class="small fw-bold text-dark mb-2 d-block ms-1">Phone Number</label>
                    <input type="tel" class="form-control border-1 border-primary rounded bg-light" 
                      v-model="service_request.contact_number" placeholder="012 345 6789">
                  </div>
                </div>
                <div v-if="service_request?.service_details?.type_name === 'on_site'" class="mb-3">
                  <label class="small fw-bold text-dark mb-2 d-block ms-1">Street Address</label>
                  
                  <input type="text" ref="serviceLocationInput" class="form-control border-1 border-primary rounded bg-light" 
                    v-model="service_request.location" placeholder="Start typing your physical address...">
                </div>

                <div class="mb-3" >
                  <label class="small fw-bold text-dark  d-block ms-1">Additional Notes</label>
                  <textarea class="form-control border-1 border-primary rounded bg-light" 
                    v-model="service_request.message" rows="5" 
                    placeholder="Tell us more about your requirements..."></textarea>
                </div>

                <button type="button" class="btn btn-primary w-100 fw-bold py-2 rounded shadow-sm" 
                  @click="submit_service_request">
                  <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                  Book Service
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

  <teleport to="body">
    <!-- Product Detail Modal -->
    <div class="modal fade" id="product_details_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm modal-dialog-scrollable">
          <div class="modal-content rounded-5 overflow-hidden border-0 shadow-lg" v-if="selected_product">

          <!-- Image Carousel -->
      <div class="modal-header border-0 shadow-sm bg-white position-relative z-index-10">
        <button
          type="button"
          class="btn-close bg-light rounded-circle shadow-sm p-2"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
        <div class="modal-body p-0">
          <div class="position-relative">
            <div id="product_image_carousel" class="carousel slide" data-bs-ride="false">
              <!-- {{selected_product}} -->
              <div class="carousel-inner">
                <div v-for="(image, index) in selected_product.images" :key="index"
                  class="carousel-item ratio ratio-4x3" :class="{ active: index === 0 }">
                  <img :src="image.image_url" class="d-block w-100 h-100 marketplace-modal-image"
                    :alt="selected_product.name + ' image ' + (index + 1)">
                </div>
                <div v-if="!selected_product.images.length" class="carousel-item active">
                  <img :src="require('@/assets/images/image_placeholder.jpg')" class="d-block" alt="Placeholder">
                </div>
              </div>

              <span v-if="selected_product.images.length > 1"
                class="position-absolute bottom-0 end-0 m-2 badge bg-dark bg-opacity-50 text-xxs">
                {{ active_image_index + 1 }} / {{ selected_product.images.length }}
              </span>
            </div>

            <!-- Thumbnails -->
            <div class="d-flex gap-2 p-2 bg-light border-rounded overflow-auto bg-danger">
              <img v-for="(image, index) in selected_product.images" :key="index" :src="image.image_url"
                class="rounded object-fit-cover flex-shrink-0 border border-2 pointer"
                :class="active_image_index === index ? 'border-dark' : 'border-transparent'" width="52" height="40"
                :alt="'Thumb ' + (index + 1)" @click="go_to_image(index)">
              <div v-if="!selected_product.images.length"
                class="rounded bg-light d-flex align-items-center justify-content-center flex-shrink-0">
                <i class="bi bi-image text-muted text-xs"></i>
              </div>
            </div>

            <span v-if="!selected_product.is_published"
              class="position-absolute top-0 start-0 m-2 badge bg-secondary text-xxs">Draft</span>
            <span v-if="selected_product.product_type?.name === 'service' && selected_product.is_published"
              class="position-absolute top-0 start-0 m-2 badge bg-primary text-xxs">Service</span>
          </div>

          <!-- Modal Body -->
          <div class="px-4 pt-3 pb-4">

            <!-- Title + Price -->
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <span class="badge bg-light text-muted text-xxs fw-semibold mb-1">
                  {{ selected_product.product_type?.name }}
                </span>
                <h5 class="fw-bold text-dark mb-0">{{ selected_product.name }}</h5>
              </div>
              <span class="fw-bold fs-5 ms-3 flex-shrink-0"
                :class="selected_product.product_type?.name === 'service' ? 'text-primary' : 'text-success'">
                R{{ format_price(display_price(selected_product)) }}
              </span>
            </div>

            <!-- Rating summary -->
            <div class="d-flex align-items-center gap-2 mb-3">
              <div class="d-flex">
              <span v-for="n in 5" :key="n">
                <i class="bi" :class="n <= selected_product.average_rating ? 'bi-star-fill text-warning' : 'bi-star text-muted'"></i>
              </span> 
              </div>
              <span class="text-muted text-xs">
                {{ selected_product.average_rating ? selected_product.average_rating : '0.0' }}
              </span>
              <span class="text-muted text-xxs">
                ({{ product_reviews.length }} reviews)
              </span>
            </div>

            <!-- Description -->
            <p v-if="selected_product.description" class="text-muted text-xs mb-4">
              {{ selected_product.description }}
            </p>

            <!-- Action button -->
            <div v-if="!active_profile" class="mb-4">
              <button v-if="selected_product.product_type?.name === 'service'"
                class="btn btn-primary w-100 rounded-3 py-2 fw-bold" data-bs-dismiss="modal"
                @click="open_service_request_modal(selected_product)">
                Request Callback
              </button>
              <button v-else class="btn w-100 rounded py-2 fw-bold"
                :class="added_to_cart === selected_product.id ? 'btn-success text-white' : 'btn-dark'"
                :disabled="adding_to_cart === selected_product.id || added_to_cart === selected_product.id"
                @click="add_to_cart(selected_product.id, selected_product.base_profile.id)">
                <span v-if="adding_to_cart === selected_product.id" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else-if="added_to_cart === selected_product.id">Added! <i class="bi bi-check2"></i></span>
                <span v-else>Add to Cart</span>
              </button>
            </div>

            <hr class="my-3">

            <!-- Rate this product (visitors only, not yet rated) -->
            <div v-if="!selected_product?.user_has_rated_product && selected_product?.can_review && !isOwner"
              class="card border bg-light rounded-5 shadow p-3 mb-4">
              <h6 class="fw-bold text-dark mb-1 d-flex align-items-center gap-2">
                <i class="bi bi-pencil-square text-primary"></i>
                Rate this {{ selected_product.product_type?.name }}
              </h6>
              <p class="text-muted small mb-2">How was your experience with this {{ selected_product.product_type?.name
                }}?</p>

              <div class="d-flex align-items-center gap-1 mb-1">
                <i v-for="n in 5" :key="n" class="pointer"
                  :class="n <= (hover_rating || new_rating) ? 'bi bi-star-fill text-warning' : 'bi bi-star text-secondary'"
                  @mouseenter="hover_rating = n" @mouseleave="hover_rating = 0" @click="new_rating = n"></i>
              </div>

              <p class="text-muted small mb-2">{{ rating_level }}</p>

              <textarea v-model="product_review_text" class="form-control form-control-sm mb-3 rounded" rows="4"
                placeholder="Share your thoughts — quality, value, reliability..."></textarea>

              <div class="d-flex justify-content-end">
                <button class="btn btn-primary btn-sm fw-semibold rounded"
                  :disabled="!new_rating || !product_review_text.trim()"
                  @click="submit_product_review(selected_product)">
                  Submit Review
                </button>
              </div>
            </div>
            <div v-if="!selected_product?.can_review"
              class="alert d-flex align-items-center gap-2 py-2 small rounded mb-4">
              <i class="bi bi-check-circle-fill"></i>
              <span>
                You can only review
                <span v-if="selected_product.product_type?.name === 'service'">services after they have been completed</span>
                <span v-else>products after they have been delivered</span>
              </span>
            </div>

            <!-- Success state after rating -->
            <div v-if="user_has_rated_product"
              class="alert alert-success d-flex align-items-center gap-2 py-2 small rounded-4 mb-4">
              <i class="bi bi-check-circle-fill"></i>
              Your review has been submitted. Thank you!
            </div>

            <!-- All Reviews -->
            <div>
              <h6 class="fw-bold text-dark mb-3">
                All Reviews
                <span class="text-muted fw-normal">({{ product_reviews.length }})</span>
              </h6>

              <div v-if="product_reviews.length === 0" class="text-center py-4 text-muted text-xs">
                No reviews yet. Be the first!
              </div>

              <div v-else class="d-flex flex-column gap-2">
                <div v-for="(review, index) in product_reviews" :key="index" class="card border bg-light rounded p-3">
                  <div class="d-flex align-items-center gap-2 mb-2 pointer">
                    <img :src="get_active_profile_picture(review.base_profile) || require('@/assets/images/user.png')"
                      alt="Rater Avatar" class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0" />
                    <div class="d-flex flex-column">
                      <div class="d-flex align-items-center gap-2 flex-wrap">
                        <span v-if="review?.base_profile?.profile_type?.toLowerCase().trim() === 'personal'"
                          @click="view_rater_profile(review?.base_profile?.user?.id)" class="fw-bold text-dark text-xs">
                          {{ review?.base_profile?.user?.first_name }} {{ review?.base_profile?.user?.last_name }}
                        </span>
                        <span v-else @click="view_company(review.base_profile)" class="fw-bold text-dark text-xs">
                          {{ review?.base_profile?.company?.company_name || 'Company Name' }}
                        </span>
                        <span v-if="String(review?.base_profile?.id) === String(active_profile_data.id)"
                          class="badge rounded-pill text-primary bg-primary-subtle border border-primary-subtle">You</span>
                      </div>
                      <span class="text-muted text-xxs">{{ format_date(review.created_at) }}</span>
                    </div>
                  </div>
                  <div class="d-flex gap-1 mb-2">
                    <i v-for="star in 5" :key="star"
                      :class="star <= review.rating ? 'bi bi-star-fill text-warning' : 'bi bi-star text-muted'"
                      class="text-xs">
                    </i>
                  </div>
                  <p class="text-muted text-xs mb-0 fst-italic">"{{ review.review }}"</p>
                </div>
              </div>
            </div>

          </div>
        </div>
        </div>
      </div>
    </div>
  </teleport>

</section>
